import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { TypeORMError } from "../../error";
import { QueryFailedError } from "../../error/QueryFailedError";
import { QueryRunnerAlreadyReleasedError } from "../../error/QueryRunnerAlreadyReleasedError";
import { TransactionNotStartedError } from "../../error/TransactionNotStartedError";
import { BaseQueryRunner } from "../../query-runner/BaseQueryRunner";
import { QueryResult } from "../../query-runner/QueryResult";
import { Table } from "../../schema-builder/table/Table";
import { TableCheck } from "../../schema-builder/table/TableCheck";
import { TableColumn } from "../../schema-builder/table/TableColumn";
import { TableExclusion } from "../../schema-builder/table/TableExclusion";
import { TableForeignKey } from "../../schema-builder/table/TableForeignKey";
import { TableIndex } from "../../schema-builder/table/TableIndex";
import { TableUnique } from "../../schema-builder/table/TableUnique";
import { View } from "../../schema-builder/view/View";
import { Broadcaster } from "../../subscriber/Broadcaster";
import { InstanceChecker } from "../../util/InstanceChecker";
import { OrmUtils } from "../../util/OrmUtils";
import { VersionUtils } from "../../util/VersionUtils";
import { Query } from "../Query";
import { MetadataTableType } from "../types/MetadataTableType";
/**
 * Runs queries on a single postgres database connection.
 */
export var PostgresQueryRunner = /*#__PURE__*/function (_BaseQueryRunner) {
  _inherits(PostgresQueryRunner, _BaseQueryRunner);
  var _super = _createSuper(PostgresQueryRunner);
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function PostgresQueryRunner(driver, mode) {
    var _this;
    _classCallCheck(this, PostgresQueryRunner);
    _this = _super.call(this);
    _this.driver = driver;
    _this.connection = driver.connection;
    _this.mode = mode;
    _this.broadcaster = new Broadcaster(_assertThisInitialized(_this));
    return _this;
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  /**
   * Creates/uses database connection from the connection pool to perform further operations.
   * Returns obtained database connection.
   */
  _createClass(PostgresQueryRunner, [{
    key: "connect",
    value: function connect() {
      var _this2 = this;
      if (this.databaseConnection) return Promise.resolve(this.databaseConnection);
      if (this.databaseConnectionPromise) return this.databaseConnectionPromise;
      if (this.mode === "slave" && this.driver.isReplicated) {
        this.databaseConnectionPromise = this.driver.obtainSlaveConnection().then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            connection = _ref2[0],
            release = _ref2[1];
          _this2.driver.connectedQueryRunners.push(_this2);
          _this2.databaseConnection = connection;
          var onErrorCallback = function onErrorCallback(err) {
            return _this2.releasePostgresConnection(err);
          };
          _this2.releaseCallback = function (err) {
            _this2.databaseConnection.removeListener("error", onErrorCallback);
            release(err);
          };
          _this2.databaseConnection.on("error", onErrorCallback);
          return _this2.databaseConnection;
        });
      } else {
        // master
        this.databaseConnectionPromise = this.driver.obtainMasterConnection().then(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            connection = _ref4[0],
            release = _ref4[1];
          _this2.driver.connectedQueryRunners.push(_this2);
          _this2.databaseConnection = connection;
          var onErrorCallback = function onErrorCallback(err) {
            return _this2.releasePostgresConnection(err);
          };
          _this2.releaseCallback = function (err) {
            _this2.databaseConnection.removeListener("error", onErrorCallback);
            release(err);
          };
          _this2.databaseConnection.on("error", onErrorCallback);
          return _this2.databaseConnection;
        });
      }
      return this.databaseConnectionPromise;
    }
    /**
     * Release a connection back to the pool, optionally specifying an Error to release with.
     * Per pg-pool documentation this will prevent the pool from re-using the broken connection.
     */
  }, {
    key: "releasePostgresConnection",
    value: function () {
      var _releasePostgresConnection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(err) {
        var index;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.isReleased) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              this.isReleased = true;
              if (this.releaseCallback) {
                this.releaseCallback(err);
                this.releaseCallback = undefined;
              }
              index = this.driver.connectedQueryRunners.indexOf(this);
              if (index !== -1) {
                this.driver.connectedQueryRunners.splice(index, 1);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function releasePostgresConnection(_x) {
        return _releasePostgresConnection.apply(this, arguments);
      }
      return releasePostgresConnection;
    }()
    /**
     * Releases used database connection.
     * You cannot use query runner methods once its released.
     */
  }, {
    key: "release",
    value: function release() {
      return this.releasePostgresConnection();
    }
    /**
     * Starts transaction.
     */
  }, {
    key: "startTransaction",
    value: function () {
      var _startTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(isolationLevel) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.isTransactionActive = true;
              _context2.prev = 1;
              _context2.next = 4;
              return this.broadcaster.broadcast("BeforeTransactionStart");
            case 4:
              _context2.next = 10;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](1);
              this.isTransactionActive = false;
              throw _context2.t0;
            case 10:
              if (!(this.transactionDepth === 0)) {
                _context2.next = 18;
                break;
              }
              _context2.next = 13;
              return this.query("START TRANSACTION");
            case 13:
              if (!isolationLevel) {
                _context2.next = 16;
                break;
              }
              _context2.next = 16;
              return this.query("SET TRANSACTION ISOLATION LEVEL " + isolationLevel);
            case 16:
              _context2.next = 20;
              break;
            case 18:
              _context2.next = 20;
              return this.query("SAVEPOINT typeorm_".concat(this.transactionDepth));
            case 20:
              this.transactionDepth += 1;
              _context2.next = 23;
              return this.broadcaster.broadcast("AfterTransactionStart");
            case 23:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 6]]);
      }));
      function startTransaction(_x2) {
        return _startTransaction.apply(this, arguments);
      }
      return startTransaction;
    }()
    /**
     * Commits transaction.
     * Error will be thrown if transaction was not started.
     */
  }, {
    key: "commitTransaction",
    value: function () {
      var _commitTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.isTransactionActive) {
                _context3.next = 2;
                break;
              }
              throw new TransactionNotStartedError();
            case 2:
              _context3.next = 4;
              return this.broadcaster.broadcast("BeforeTransactionCommit");
            case 4:
              if (!(this.transactionDepth > 1)) {
                _context3.next = 9;
                break;
              }
              _context3.next = 7;
              return this.query("RELEASE SAVEPOINT typeorm_".concat(this.transactionDepth - 1));
            case 7:
              _context3.next = 12;
              break;
            case 9:
              _context3.next = 11;
              return this.query("COMMIT");
            case 11:
              this.isTransactionActive = false;
            case 12:
              this.transactionDepth -= 1;
              _context3.next = 15;
              return this.broadcaster.broadcast("AfterTransactionCommit");
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function commitTransaction() {
        return _commitTransaction.apply(this, arguments);
      }
      return commitTransaction;
    }()
    /**
     * Rollbacks transaction.
     * Error will be thrown if transaction was not started.
     */
  }, {
    key: "rollbackTransaction",
    value: function () {
      var _rollbackTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.isTransactionActive) {
                _context4.next = 2;
                break;
              }
              throw new TransactionNotStartedError();
            case 2:
              _context4.next = 4;
              return this.broadcaster.broadcast("BeforeTransactionRollback");
            case 4:
              if (!(this.transactionDepth > 1)) {
                _context4.next = 9;
                break;
              }
              _context4.next = 7;
              return this.query("ROLLBACK TO SAVEPOINT typeorm_".concat(this.transactionDepth - 1));
            case 7:
              _context4.next = 12;
              break;
            case 9:
              _context4.next = 11;
              return this.query("ROLLBACK");
            case 11:
              this.isTransactionActive = false;
            case 12:
              this.transactionDepth -= 1;
              _context4.next = 15;
              return this.broadcaster.broadcast("AfterTransactionRollback");
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function rollbackTransaction() {
        return _rollbackTransaction.apply(this, arguments);
      }
      return rollbackTransaction;
    }()
    /**
     * Executes a given SQL query.
     */
  }, {
    key: "query",
    value: function () {
      var _query2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_query, parameters) {
        var useStructuredResult,
          databaseConnection,
          queryStartTime,
          raw,
          maxQueryExecutionTime,
          queryEndTime,
          queryExecutionTime,
          result,
          _args5 = arguments;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              useStructuredResult = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : false;
              if (!this.isReleased) {
                _context5.next = 3;
                break;
              }
              throw new QueryRunnerAlreadyReleasedError();
            case 3:
              _context5.next = 5;
              return this.connect();
            case 5:
              databaseConnection = _context5.sent;
              this.driver.connection.logger.logQuery(_query, parameters, this);
              _context5.prev = 7;
              queryStartTime = +new Date();
              _context5.next = 11;
              return databaseConnection.query(_query, parameters);
            case 11:
              raw = _context5.sent;
              // log slow queries if maxQueryExecution time is set
              maxQueryExecutionTime = this.driver.options.maxQueryExecutionTime;
              queryEndTime = +new Date();
              queryExecutionTime = queryEndTime - queryStartTime;
              if (maxQueryExecutionTime && queryExecutionTime > maxQueryExecutionTime) this.driver.connection.logger.logQuerySlow(queryExecutionTime, _query, parameters, this);
              result = new QueryResult();
              if (!raw) {
                _context5.next = 28;
                break;
              }
              if (raw.hasOwnProperty("rows")) {
                result.records = raw.rows;
              }
              if (raw.hasOwnProperty("rowCount")) {
                result.affected = raw.rowCount;
              }
              _context5.t0 = raw.command;
              _context5.next = _context5.t0 === "DELETE" ? 23 : _context5.t0 === "UPDATE" ? 23 : 25;
              break;
            case 23:
              // for UPDATE and DELETE query additionally return number of affected rows
              result.raw = [raw.rows, raw.rowCount];
              return _context5.abrupt("break", 26);
            case 25:
              result.raw = raw.rows;
            case 26:
              if (useStructuredResult) {
                _context5.next = 28;
                break;
              }
              return _context5.abrupt("return", result.raw);
            case 28:
              return _context5.abrupt("return", result);
            case 31:
              _context5.prev = 31;
              _context5.t1 = _context5["catch"](7);
              this.driver.connection.logger.logQueryError(_context5.t1, _query, parameters, this);
              throw new QueryFailedError(_query, parameters, _context5.t1);
            case 35:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[7, 31]]);
      }));
      function query(_x3, _x4) {
        return _query2.apply(this, arguments);
      }
      return query;
    }()
    /**
     * Returns raw data stream.
     */
  }, {
    key: "stream",
    value: function () {
      var _stream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(query, parameters, onEnd, onError) {
        var QueryStream, databaseConnection, stream;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              QueryStream = this.driver.loadStreamDependency();
              if (!this.isReleased) {
                _context6.next = 3;
                break;
              }
              throw new QueryRunnerAlreadyReleasedError();
            case 3:
              _context6.next = 5;
              return this.connect();
            case 5:
              databaseConnection = _context6.sent;
              this.driver.connection.logger.logQuery(query, parameters, this);
              stream = databaseConnection.query(new QueryStream(query, parameters));
              if (onEnd) stream.on("end", onEnd);
              if (onError) stream.on("error", onError);
              return _context6.abrupt("return", stream);
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function stream(_x5, _x6, _x7, _x8) {
        return _stream.apply(this, arguments);
      }
      return stream;
    }()
    /**
     * Returns all available database names including system databases.
     */
  }, {
    key: "getDatabases",
    value: function () {
      var _getDatabases = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", Promise.resolve([]));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function getDatabases() {
        return _getDatabases.apply(this, arguments);
      }
      return getDatabases;
    }()
    /**
     * Returns all available schema names including system schemas.
     * If database parameter specified, returns schemas of that database.
     */
  }, {
    key: "getSchemas",
    value: function () {
      var _getSchemas = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(database) {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", Promise.resolve([]));
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function getSchemas(_x9) {
        return _getSchemas.apply(this, arguments);
      }
      return getSchemas;
    }()
    /**
     * Checks if database with the given name exist.
     */
  }, {
    key: "hasDatabase",
    value: function () {
      var _hasDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(database) {
        var result;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.query("SELECT * FROM pg_database WHERE datname='".concat(database, "';"));
            case 2:
              result = _context9.sent;
              return _context9.abrupt("return", result.length ? true : false);
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function hasDatabase(_x10) {
        return _hasDatabase.apply(this, arguments);
      }
      return hasDatabase;
    }()
    /**
     * Loads currently using database
     */
  }, {
    key: "getCurrentDatabase",
    value: function () {
      var _getCurrentDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var query;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.query("SELECT * FROM current_database()");
            case 2:
              query = _context10.sent;
              return _context10.abrupt("return", query[0]["current_database"]);
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getCurrentDatabase() {
        return _getCurrentDatabase.apply(this, arguments);
      }
      return getCurrentDatabase;
    }()
    /**
     * Checks if schema with the given name exist.
     */
  }, {
    key: "hasSchema",
    value: function () {
      var _hasSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(schema) {
        var result;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.query("SELECT * FROM \"information_schema\".\"schemata\" WHERE \"schema_name\" = '".concat(schema, "'"));
            case 2:
              result = _context11.sent;
              return _context11.abrupt("return", result.length ? true : false);
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function hasSchema(_x11) {
        return _hasSchema.apply(this, arguments);
      }
      return hasSchema;
    }()
    /**
     * Loads currently using database schema
     */
  }, {
    key: "getCurrentSchema",
    value: function () {
      var _getCurrentSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var query;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.query("SELECT * FROM current_schema()");
            case 2:
              query = _context12.sent;
              return _context12.abrupt("return", query[0]["current_schema"]);
            case 4:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getCurrentSchema() {
        return _getCurrentSchema.apply(this, arguments);
      }
      return getCurrentSchema;
    }()
    /**
     * Checks if table with the given name exist in the database.
     */
  }, {
    key: "hasTable",
    value: function () {
      var _hasTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(tableOrName) {
        var parsedTableName, sql, result;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              parsedTableName = this.driver.parseTableName(tableOrName);
              if (parsedTableName.schema) {
                _context13.next = 5;
                break;
              }
              _context13.next = 4;
              return this.getCurrentSchema();
            case 4:
              parsedTableName.schema = _context13.sent;
            case 5:
              sql = "SELECT * FROM \"information_schema\".\"tables\" WHERE \"table_schema\" = '".concat(parsedTableName.schema, "' AND \"table_name\" = '").concat(parsedTableName.tableName, "'");
              _context13.next = 8;
              return this.query(sql);
            case 8:
              result = _context13.sent;
              return _context13.abrupt("return", result.length ? true : false);
            case 10:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function hasTable(_x12) {
        return _hasTable.apply(this, arguments);
      }
      return hasTable;
    }()
    /**
     * Checks if column with the given name exist in the given table.
     */
  }, {
    key: "hasColumn",
    value: function () {
      var _hasColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(tableOrName, columnName) {
        var parsedTableName, sql, result;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              parsedTableName = this.driver.parseTableName(tableOrName);
              if (parsedTableName.schema) {
                _context14.next = 5;
                break;
              }
              _context14.next = 4;
              return this.getCurrentSchema();
            case 4:
              parsedTableName.schema = _context14.sent;
            case 5:
              sql = "SELECT * FROM \"information_schema\".\"columns\" WHERE \"table_schema\" = '".concat(parsedTableName.schema, "' AND \"table_name\" = '").concat(parsedTableName.tableName, "' AND \"column_name\" = '").concat(columnName, "'");
              _context14.next = 8;
              return this.query(sql);
            case 8:
              result = _context14.sent;
              return _context14.abrupt("return", result.length ? true : false);
            case 10:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function hasColumn(_x13, _x14) {
        return _hasColumn.apply(this, arguments);
      }
      return hasColumn;
    }()
    /**
     * Creates a new database.
     * Note: Postgres does not support database creation inside a transaction block.
     */
  }, {
    key: "createDatabase",
    value: function () {
      var _createDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(database, ifNotExist) {
        var databaseAlreadyExists, up, down;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!ifNotExist) {
                _context15.next = 6;
                break;
              }
              _context15.next = 3;
              return this.hasDatabase(database);
            case 3:
              databaseAlreadyExists = _context15.sent;
              if (!databaseAlreadyExists) {
                _context15.next = 6;
                break;
              }
              return _context15.abrupt("return", Promise.resolve());
            case 6:
              up = "CREATE DATABASE \"".concat(database, "\"");
              down = "DROP DATABASE \"".concat(database, "\"");
              _context15.next = 10;
              return this.executeQueries(new Query(up), new Query(down));
            case 10:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function createDatabase(_x15, _x16) {
        return _createDatabase.apply(this, arguments);
      }
      return createDatabase;
    }()
    /**
     * Drops database.
     * Note: Postgres does not support database dropping inside a transaction block.
     */
  }, {
    key: "dropDatabase",
    value: function () {
      var _dropDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(database, ifExist) {
        var up, down;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              up = ifExist ? "DROP DATABASE IF EXISTS \"".concat(database, "\"") : "DROP DATABASE \"".concat(database, "\"");
              down = "CREATE DATABASE \"".concat(database, "\"");
              _context16.next = 4;
              return this.executeQueries(new Query(up), new Query(down));
            case 4:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function dropDatabase(_x17, _x18) {
        return _dropDatabase.apply(this, arguments);
      }
      return dropDatabase;
    }()
    /**
     * Creates a new table schema.
     */
  }, {
    key: "createSchema",
    value: function () {
      var _createSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(schemaPath, ifNotExist) {
        var schema, up, down;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              schema = schemaPath.indexOf(".") === -1 ? schemaPath : schemaPath.split(".")[1];
              up = ifNotExist ? "CREATE SCHEMA IF NOT EXISTS \"".concat(schema, "\"") : "CREATE SCHEMA \"".concat(schema, "\"");
              down = "DROP SCHEMA \"".concat(schema, "\" CASCADE");
              _context17.next = 5;
              return this.executeQueries(new Query(up), new Query(down));
            case 5:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function createSchema(_x19, _x20) {
        return _createSchema.apply(this, arguments);
      }
      return createSchema;
    }()
    /**
     * Drops table schema.
     */
  }, {
    key: "dropSchema",
    value: function () {
      var _dropSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(schemaPath, ifExist, isCascade) {
        var schema, up, down;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              schema = schemaPath.indexOf(".") === -1 ? schemaPath : schemaPath.split(".")[1];
              up = ifExist ? "DROP SCHEMA IF EXISTS \"".concat(schema, "\" ").concat(isCascade ? "CASCADE" : "") : "DROP SCHEMA \"".concat(schema, "\" ").concat(isCascade ? "CASCADE" : "");
              down = "CREATE SCHEMA \"".concat(schema, "\"");
              _context18.next = 5;
              return this.executeQueries(new Query(up), new Query(down));
            case 5:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function dropSchema(_x21, _x22, _x23) {
        return _dropSchema.apply(this, arguments);
      }
      return dropSchema;
    }()
    /**
     * Creates a new table.
     */
  }, {
    key: "createTable",
    value: function () {
      var _createTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(table) {
        var _this3 = this;
        var ifNotExist,
          createForeignKeys,
          createIndices,
          isTableExist,
          upQueries,
          downQueries,
          enumColumns,
          createdEnumTypes,
          _iterator,
          _step,
          column,
          hasEnum,
          enumName,
          generatedColumns,
          _iterator2,
          _step2,
          _column,
          tableNameWithSchema,
          tableName,
          schema,
          insertQuery,
          deleteQuery,
          _args19 = arguments;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              ifNotExist = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : false;
              createForeignKeys = _args19.length > 2 && _args19[2] !== undefined ? _args19[2] : true;
              createIndices = _args19.length > 3 && _args19[3] !== undefined ? _args19[3] : true;
              if (!ifNotExist) {
                _context19.next = 9;
                break;
              }
              _context19.next = 6;
              return this.hasTable(table);
            case 6:
              isTableExist = _context19.sent;
              if (!isTableExist) {
                _context19.next = 9;
                break;
              }
              return _context19.abrupt("return", Promise.resolve());
            case 9:
              upQueries = [];
              downQueries = []; // if table have column with ENUM type, we must create this type in postgres.
              enumColumns = table.columns.filter(function (column) {
                return column.type === "enum" || column.type === "simple-enum";
              });
              createdEnumTypes = [];
              _iterator = _createForOfIteratorHelper(enumColumns);
              _context19.prev = 14;
              _iterator.s();
            case 16:
              if ((_step = _iterator.n()).done) {
                _context19.next = 25;
                break;
              }
              column = _step.value;
              _context19.next = 20;
              return this.hasEnumType(table, column);
            case 20:
              hasEnum = _context19.sent;
              enumName = this.buildEnumName(table, column); // if enum with the same "enumName" is defined more then once, me must prevent double creation
              if (!hasEnum && createdEnumTypes.indexOf(enumName) === -1) {
                createdEnumTypes.push(enumName);
                upQueries.push(this.createEnumTypeSql(table, column, enumName));
                downQueries.push(this.dropEnumTypeSql(table, column, enumName));
              }
            case 23:
              _context19.next = 16;
              break;
            case 25:
              _context19.next = 30;
              break;
            case 27:
              _context19.prev = 27;
              _context19.t0 = _context19["catch"](14);
              _iterator.e(_context19.t0);
            case 30:
              _context19.prev = 30;
              _iterator.f();
              return _context19.finish(30);
            case 33:
              // if table have column with generated type, we must add the expression to the metadata table
              generatedColumns = table.columns.filter(function (column) {
                return column.generatedType === "STORED" && column.asExpression;
              });
              _iterator2 = _createForOfIteratorHelper(generatedColumns);
              _context19.prev = 35;
              _iterator2.s();
            case 37:
              if ((_step2 = _iterator2.n()).done) {
                _context19.next = 50;
                break;
              }
              _column = _step2.value;
              _context19.next = 41;
              return this.getTableNameWithSchema(table.name);
            case 41:
              tableNameWithSchema = _context19.sent.split(".");
              tableName = tableNameWithSchema[1];
              schema = tableNameWithSchema[0];
              insertQuery = this.insertTypeormMetadataSql({
                database: this.driver.database,
                schema: schema,
                table: tableName,
                type: MetadataTableType.GENERATED_COLUMN,
                name: _column.name,
                value: _column.asExpression
              });
              deleteQuery = this.deleteTypeormMetadataSql({
                database: this.driver.database,
                schema: schema,
                table: tableName,
                type: MetadataTableType.GENERATED_COLUMN,
                name: _column.name
              });
              upQueries.push(insertQuery);
              downQueries.push(deleteQuery);
            case 48:
              _context19.next = 37;
              break;
            case 50:
              _context19.next = 55;
              break;
            case 52:
              _context19.prev = 52;
              _context19.t1 = _context19["catch"](35);
              _iterator2.e(_context19.t1);
            case 55:
              _context19.prev = 55;
              _iterator2.f();
              return _context19.finish(55);
            case 58:
              upQueries.push(this.createTableSql(table, createForeignKeys));
              downQueries.push(this.dropTableSql(table));
              // if createForeignKeys is true, we must drop created foreign keys in down query.
              // createTable does not need separate method to create foreign keys, because it create fk's in the same query with table creation.
              if (createForeignKeys) table.foreignKeys.forEach(function (foreignKey) {
                return downQueries.push(_this3.dropForeignKeySql(table, foreignKey));
              });
              if (createIndices) {
                table.indices.forEach(function (index) {
                  // new index may be passed without name. In this case we generate index name manually.
                  if (!index.name) index.name = _this3.connection.namingStrategy.indexName(table, index.columnNames, index.where);
                  upQueries.push(_this3.createIndexSql(table, index));
                  downQueries.push(_this3.dropIndexSql(table, index));
                });
              }
              _context19.next = 64;
              return this.executeQueries(upQueries, downQueries);
            case 64:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this, [[14, 27, 30, 33], [35, 52, 55, 58]]);
      }));
      function createTable(_x24) {
        return _createTable.apply(this, arguments);
      }
      return createTable;
    }()
    /**
     * Drops the table.
     */
  }, {
    key: "dropTable",
    value: function () {
      var _dropTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(target, ifExist) {
        var _this4 = this;
        var dropForeignKeys,
          dropIndices,
          isTableExist,
          createForeignKeys,
          tablePath,
          table,
          upQueries,
          downQueries,
          generatedColumns,
          _iterator3,
          _step3,
          column,
          tableNameWithSchema,
          tableName,
          schema,
          deleteQuery,
          insertQuery,
          _args20 = arguments;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              dropForeignKeys = _args20.length > 2 && _args20[2] !== undefined ? _args20[2] : true;
              dropIndices = _args20.length > 3 && _args20[3] !== undefined ? _args20[3] : true;
              if (!ifExist) {
                _context20.next = 8;
                break;
              }
              _context20.next = 5;
              return this.hasTable(target);
            case 5:
              isTableExist = _context20.sent;
              if (isTableExist) {
                _context20.next = 8;
                break;
              }
              return _context20.abrupt("return", Promise.resolve());
            case 8:
              // if dropTable called with dropForeignKeys = true, we must create foreign keys in down query.
              createForeignKeys = dropForeignKeys;
              tablePath = this.getTablePath(target);
              _context20.next = 12;
              return this.getCachedTable(tablePath);
            case 12:
              table = _context20.sent;
              upQueries = [];
              downQueries = [];
              if (dropIndices) {
                table.indices.forEach(function (index) {
                  upQueries.push(_this4.dropIndexSql(table, index));
                  downQueries.push(_this4.createIndexSql(table, index));
                });
              }
              if (dropForeignKeys) table.foreignKeys.forEach(function (foreignKey) {
                return upQueries.push(_this4.dropForeignKeySql(table, foreignKey));
              });
              upQueries.push(this.dropTableSql(table));
              downQueries.push(this.createTableSql(table, createForeignKeys));
              // if table had columns with generated type, we must remove the expression from the metadata table
              generatedColumns = table.columns.filter(function (column) {
                return column.generatedType && column.asExpression;
              });
              _iterator3 = _createForOfIteratorHelper(generatedColumns);
              _context20.prev = 21;
              _iterator3.s();
            case 23:
              if ((_step3 = _iterator3.n()).done) {
                _context20.next = 36;
                break;
              }
              column = _step3.value;
              _context20.next = 27;
              return this.getTableNameWithSchema(table.name);
            case 27:
              tableNameWithSchema = _context20.sent.split(".");
              tableName = tableNameWithSchema[1];
              schema = tableNameWithSchema[0];
              deleteQuery = this.deleteTypeormMetadataSql({
                database: this.driver.database,
                schema: schema,
                table: tableName,
                type: MetadataTableType.GENERATED_COLUMN,
                name: column.name
              });
              insertQuery = this.insertTypeormMetadataSql({
                database: this.driver.database,
                schema: schema,
                table: tableName,
                type: MetadataTableType.GENERATED_COLUMN,
                name: column.name,
                value: column.asExpression
              });
              upQueries.push(deleteQuery);
              downQueries.push(insertQuery);
            case 34:
              _context20.next = 23;
              break;
            case 36:
              _context20.next = 41;
              break;
            case 38:
              _context20.prev = 38;
              _context20.t0 = _context20["catch"](21);
              _iterator3.e(_context20.t0);
            case 41:
              _context20.prev = 41;
              _iterator3.f();
              return _context20.finish(41);
            case 44:
              _context20.next = 46;
              return this.executeQueries(upQueries, downQueries);
            case 46:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this, [[21, 38, 41, 44]]);
      }));
      function dropTable(_x25, _x26) {
        return _dropTable.apply(this, arguments);
      }
      return dropTable;
    }()
    /**
     * Creates a new view.
     */
  }, {
    key: "createView",
    value: function () {
      var _createView = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(view) {
        var syncWithMetadata,
          upQueries,
          downQueries,
          _args21 = arguments;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              syncWithMetadata = _args21.length > 1 && _args21[1] !== undefined ? _args21[1] : false;
              upQueries = [];
              downQueries = [];
              upQueries.push(this.createViewSql(view));
              if (!syncWithMetadata) {
                _context21.next = 10;
                break;
              }
              _context21.t0 = upQueries;
              _context21.next = 8;
              return this.insertViewDefinitionSql(view);
            case 8:
              _context21.t1 = _context21.sent;
              _context21.t0.push.call(_context21.t0, _context21.t1);
            case 10:
              downQueries.push(this.dropViewSql(view));
              if (!syncWithMetadata) {
                _context21.next = 17;
                break;
              }
              _context21.t2 = downQueries;
              _context21.next = 15;
              return this.deleteViewDefinitionSql(view);
            case 15:
              _context21.t3 = _context21.sent;
              _context21.t2.push.call(_context21.t2, _context21.t3);
            case 17:
              _context21.next = 19;
              return this.executeQueries(upQueries, downQueries);
            case 19:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function createView(_x27) {
        return _createView.apply(this, arguments);
      }
      return createView;
    }()
    /**
     * Drops the view.
     */
  }, {
    key: "dropView",
    value: function () {
      var _dropView = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(target) {
        var viewName, view, upQueries, downQueries;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              viewName = InstanceChecker.isView(target) ? target.name : target;
              _context22.next = 3;
              return this.getCachedView(viewName);
            case 3:
              view = _context22.sent;
              upQueries = [];
              downQueries = [];
              _context22.t0 = upQueries;
              _context22.next = 9;
              return this.deleteViewDefinitionSql(view);
            case 9:
              _context22.t1 = _context22.sent;
              _context22.t0.push.call(_context22.t0, _context22.t1);
              upQueries.push(this.dropViewSql(view));
              _context22.t2 = downQueries;
              _context22.next = 15;
              return this.insertViewDefinitionSql(view);
            case 15:
              _context22.t3 = _context22.sent;
              _context22.t2.push.call(_context22.t2, _context22.t3);
              downQueries.push(this.createViewSql(view));
              _context22.next = 20;
              return this.executeQueries(upQueries, downQueries);
            case 20:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function dropView(_x28) {
        return _dropView.apply(this, arguments);
      }
      return dropView;
    }()
    /**
     * Renames the given table.
     */
  }, {
    key: "renameTable",
    value: function () {
      var _renameTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(oldTableOrName, newTableName) {
        var _this5 = this;
        var upQueries, downQueries, oldTable, newTable, _this$driver$parseTab, schemaName, oldTableName, columnNames, oldPkName, newPkName, enumColumns, _iterator4, _step4, column, oldEnumType;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              upQueries = [];
              downQueries = [];
              if (!InstanceChecker.isTable(oldTableOrName)) {
                _context23.next = 6;
                break;
              }
              _context23.t0 = oldTableOrName;
              _context23.next = 9;
              break;
            case 6:
              _context23.next = 8;
              return this.getCachedTable(oldTableOrName);
            case 8:
              _context23.t0 = _context23.sent;
            case 9:
              oldTable = _context23.t0;
              newTable = oldTable.clone();
              _this$driver$parseTab = this.driver.parseTableName(oldTable), schemaName = _this$driver$parseTab.schema, oldTableName = _this$driver$parseTab.tableName;
              newTable.name = schemaName ? "".concat(schemaName, ".").concat(newTableName) : newTableName;
              upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(oldTable), " RENAME TO \"").concat(newTableName, "\"")));
              downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(newTable), " RENAME TO \"").concat(oldTableName, "\"")));
              // rename column primary key constraint if it has default constraint name
              if (newTable.primaryColumns.length > 0 && !newTable.primaryColumns[0].primaryKeyConstraintName) {
                columnNames = newTable.primaryColumns.map(function (column) {
                  return column.name;
                });
                oldPkName = this.connection.namingStrategy.primaryKeyName(oldTable, columnNames);
                newPkName = this.connection.namingStrategy.primaryKeyName(newTable, columnNames);
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(newTable), " RENAME CONSTRAINT \"").concat(oldPkName, "\" TO \"").concat(newPkName, "\"")));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(newTable), " RENAME CONSTRAINT \"").concat(newPkName, "\" TO \"").concat(oldPkName, "\"")));
              }
              // rename sequences
              newTable.columns.map(function (col) {
                if (col.isGenerated && col.generationStrategy === "increment") {
                  var sequencePath = _this5.buildSequencePath(oldTable, col.name);
                  var sequenceName = _this5.buildSequenceName(oldTable, col.name);
                  var newSequencePath = _this5.buildSequencePath(newTable, col.name);
                  var newSequenceName = _this5.buildSequenceName(newTable, col.name);
                  var up = "ALTER SEQUENCE ".concat(_this5.escapePath(sequencePath), " RENAME TO \"").concat(newSequenceName, "\"");
                  var down = "ALTER SEQUENCE ".concat(_this5.escapePath(newSequencePath), " RENAME TO \"").concat(sequenceName, "\"");
                  upQueries.push(new Query(up));
                  downQueries.push(new Query(down));
                }
              });
              // rename unique constraints
              newTable.uniques.forEach(function (unique) {
                var oldUniqueName = _this5.connection.namingStrategy.uniqueConstraintName(oldTable, unique.columnNames);
                // Skip renaming if Unique has user defined constraint name
                if (unique.name !== oldUniqueName) return;
                // build new constraint name
                var newUniqueName = _this5.connection.namingStrategy.uniqueConstraintName(newTable, unique.columnNames);
                // build queries
                upQueries.push(new Query("ALTER TABLE ".concat(_this5.escapePath(newTable), " RENAME CONSTRAINT \"").concat(unique.name, "\" TO \"").concat(newUniqueName, "\"")));
                downQueries.push(new Query("ALTER TABLE ".concat(_this5.escapePath(newTable), " RENAME CONSTRAINT \"").concat(newUniqueName, "\" TO \"").concat(unique.name, "\"")));
                // replace constraint name
                unique.name = newUniqueName;
              });
              // rename index constraints
              newTable.indices.forEach(function (index) {
                var oldIndexName = _this5.connection.namingStrategy.indexName(oldTable, index.columnNames, index.where);
                // Skip renaming if Index has user defined constraint name
                if (index.name !== oldIndexName) return;
                // build new constraint name
                var _this5$driver$parseTa = _this5.driver.parseTableName(newTable),
                  schema = _this5$driver$parseTa.schema;
                var newIndexName = _this5.connection.namingStrategy.indexName(newTable, index.columnNames, index.where);
                // build queries
                var up = schema ? "ALTER INDEX \"".concat(schema, "\".\"").concat(index.name, "\" RENAME TO \"").concat(newIndexName, "\"") : "ALTER INDEX \"".concat(index.name, "\" RENAME TO \"").concat(newIndexName, "\"");
                var down = schema ? "ALTER INDEX \"".concat(schema, "\".\"").concat(newIndexName, "\" RENAME TO \"").concat(index.name, "\"") : "ALTER INDEX \"".concat(newIndexName, "\" RENAME TO \"").concat(index.name, "\"");
                upQueries.push(new Query(up));
                downQueries.push(new Query(down));
                // replace constraint name
                index.name = newIndexName;
              });
              // rename foreign key constraints
              newTable.foreignKeys.forEach(function (foreignKey) {
                var oldForeignKeyName = _this5.connection.namingStrategy.foreignKeyName(oldTable, foreignKey.columnNames, _this5.getTablePath(foreignKey), foreignKey.referencedColumnNames);
                // Skip renaming if foreign key has user defined constraint name
                if (foreignKey.name !== oldForeignKeyName) return;
                // build new constraint name
                var newForeignKeyName = _this5.connection.namingStrategy.foreignKeyName(newTable, foreignKey.columnNames, _this5.getTablePath(foreignKey), foreignKey.referencedColumnNames);
                // build queries
                upQueries.push(new Query("ALTER TABLE ".concat(_this5.escapePath(newTable), " RENAME CONSTRAINT \"").concat(foreignKey.name, "\" TO \"").concat(newForeignKeyName, "\"")));
                downQueries.push(new Query("ALTER TABLE ".concat(_this5.escapePath(newTable), " RENAME CONSTRAINT \"").concat(newForeignKeyName, "\" TO \"").concat(foreignKey.name, "\"")));
                // replace constraint name
                foreignKey.name = newForeignKeyName;
              });
              // rename ENUM types
              enumColumns = newTable.columns.filter(function (column) {
                return column.type === "enum" || column.type === "simple-enum";
              });
              _iterator4 = _createForOfIteratorHelper(enumColumns);
              _context23.prev = 22;
              _iterator4.s();
            case 24:
              if ((_step4 = _iterator4.n()).done) {
                _context23.next = 35;
                break;
              }
              column = _step4.value;
              if (!column.enumName) {
                _context23.next = 28;
                break;
              }
              return _context23.abrupt("continue", 33);
            case 28:
              _context23.next = 30;
              return this.getUserDefinedTypeName(oldTable, column);
            case 30:
              oldEnumType = _context23.sent;
              upQueries.push(new Query("ALTER TYPE \"".concat(oldEnumType.schema, "\".\"").concat(oldEnumType.name, "\" RENAME TO ").concat(this.buildEnumName(newTable, column, false))));
              downQueries.push(new Query("ALTER TYPE ".concat(this.buildEnumName(newTable, column), " RENAME TO \"").concat(oldEnumType.name, "\"")));
            case 33:
              _context23.next = 24;
              break;
            case 35:
              _context23.next = 40;
              break;
            case 37:
              _context23.prev = 37;
              _context23.t1 = _context23["catch"](22);
              _iterator4.e(_context23.t1);
            case 40:
              _context23.prev = 40;
              _iterator4.f();
              return _context23.finish(40);
            case 43:
              _context23.next = 45;
              return this.executeQueries(upQueries, downQueries);
            case 45:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this, [[22, 37, 40, 43]]);
      }));
      function renameTable(_x29, _x30) {
        return _renameTable.apply(this, arguments);
      }
      return renameTable;
    }()
    /**
     * Creates a new column from the column in the table.
     */
  }, {
    key: "addColumn",
    value: function () {
      var _addColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(tableOrName, column) {
        var table, clonedTable, upQueries, downQueries, hasEnum, primaryColumns, _pkName, _columnNames, pkName, columnNames, columnIndex, uniqueConstraint, tableNameWithSchema, tableName, schema, insertQuery, deleteQuery;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context24.next = 4;
                break;
              }
              _context24.t0 = tableOrName;
              _context24.next = 7;
              break;
            case 4:
              _context24.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context24.t0 = _context24.sent;
            case 7:
              table = _context24.t0;
              clonedTable = table.clone();
              upQueries = [];
              downQueries = [];
              if (!(column.type === "enum" || column.type === "simple-enum")) {
                _context24.next = 16;
                break;
              }
              _context24.next = 14;
              return this.hasEnumType(table, column);
            case 14:
              hasEnum = _context24.sent;
              if (!hasEnum) {
                upQueries.push(this.createEnumTypeSql(table, column));
                downQueries.push(this.dropEnumTypeSql(table, column));
              }
            case 16:
              upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD ").concat(this.buildCreateColumnSql(table, column))));
              downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP COLUMN \"").concat(column.name, "\"")));
              // create or update primary key constraint
              if (column.isPrimary) {
                primaryColumns = clonedTable.primaryColumns; // if table already have primary key, me must drop it and recreate again
                if (primaryColumns.length > 0) {
                  _pkName = primaryColumns[0].primaryKeyConstraintName ? primaryColumns[0].primaryKeyConstraintName : this.connection.namingStrategy.primaryKeyName(clonedTable, primaryColumns.map(function (column) {
                    return column.name;
                  }));
                  _columnNames = primaryColumns.map(function (column) {
                    return "\"".concat(column.name, "\"");
                  }).join(", ");
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP CONSTRAINT \"").concat(_pkName, "\"")));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT \"").concat(_pkName, "\" PRIMARY KEY (").concat(_columnNames, ")")));
                }
                primaryColumns.push(column);
                pkName = primaryColumns[0].primaryKeyConstraintName ? primaryColumns[0].primaryKeyConstraintName : this.connection.namingStrategy.primaryKeyName(clonedTable, primaryColumns.map(function (column) {
                  return column.name;
                }));
                columnNames = primaryColumns.map(function (column) {
                  return "\"".concat(column.name, "\"");
                }).join(", ");
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT \"").concat(pkName, "\" PRIMARY KEY (").concat(columnNames, ")")));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP CONSTRAINT \"").concat(pkName, "\"")));
              }
              // create column index
              columnIndex = clonedTable.indices.find(function (index) {
                return index.columnNames.length === 1 && index.columnNames[0] === column.name;
              });
              if (columnIndex) {
                upQueries.push(this.createIndexSql(table, columnIndex));
                downQueries.push(this.dropIndexSql(table, columnIndex));
              }
              // create unique constraint
              if (column.isUnique) {
                uniqueConstraint = new TableUnique({
                  name: this.connection.namingStrategy.uniqueConstraintName(table, [column.name]),
                  columnNames: [column.name]
                });
                clonedTable.uniques.push(uniqueConstraint);
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT \"").concat(uniqueConstraint.name, "\" UNIQUE (\"").concat(column.name, "\")")));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP CONSTRAINT \"").concat(uniqueConstraint.name, "\"")));
              }
              if (!(column.generatedType === "STORED" && column.asExpression)) {
                _context24.next = 32;
                break;
              }
              _context24.next = 25;
              return this.getTableNameWithSchema(table.name);
            case 25:
              tableNameWithSchema = _context24.sent.split(".");
              tableName = tableNameWithSchema[1];
              schema = tableNameWithSchema[0];
              insertQuery = this.insertTypeormMetadataSql({
                database: this.driver.database,
                schema: schema,
                table: tableName,
                type: MetadataTableType.GENERATED_COLUMN,
                name: column.name,
                value: column.asExpression
              });
              deleteQuery = this.deleteTypeormMetadataSql({
                database: this.driver.database,
                schema: schema,
                table: tableName,
                type: MetadataTableType.GENERATED_COLUMN,
                name: column.name
              });
              upQueries.push(insertQuery);
              downQueries.push(deleteQuery);
            case 32:
              // create column's comment
              if (column.comment) {
                upQueries.push(new Query("COMMENT ON COLUMN ".concat(this.escapePath(table), ".\"").concat(column.name, "\" IS ").concat(this.escapeComment(column.comment))));
                downQueries.push(new Query("COMMENT ON COLUMN ".concat(this.escapePath(table), ".\"").concat(column.name, "\" IS ").concat(this.escapeComment(column.comment))));
              }
              _context24.next = 35;
              return this.executeQueries(upQueries, downQueries);
            case 35:
              clonedTable.addColumn(column);
              this.replaceCachedTable(table, clonedTable);
            case 37:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function addColumn(_x31, _x32) {
        return _addColumn.apply(this, arguments);
      }
      return addColumn;
    }()
    /**
     * Creates a new columns from the column in the table.
     */
  }, {
    key: "addColumns",
    value: function () {
      var _addColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(tableOrName, columns) {
        var _iterator5, _step5, column;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _iterator5 = _createForOfIteratorHelper(columns);
              _context25.prev = 1;
              _iterator5.s();
            case 3:
              if ((_step5 = _iterator5.n()).done) {
                _context25.next = 9;
                break;
              }
              column = _step5.value;
              _context25.next = 7;
              return this.addColumn(tableOrName, column);
            case 7:
              _context25.next = 3;
              break;
            case 9:
              _context25.next = 14;
              break;
            case 11:
              _context25.prev = 11;
              _context25.t0 = _context25["catch"](1);
              _iterator5.e(_context25.t0);
            case 14:
              _context25.prev = 14;
              _iterator5.f();
              return _context25.finish(14);
            case 17:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this, [[1, 11, 14, 17]]);
      }));
      function addColumns(_x33, _x34) {
        return _addColumns.apply(this, arguments);
      }
      return addColumns;
    }()
    /**
     * Renames column in the given table.
     */
  }, {
    key: "renameColumn",
    value: function () {
      var _renameColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(tableOrName, oldTableColumnOrName, newTableColumnOrName) {
        var table, oldColumn, newColumn;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context26.next = 4;
                break;
              }
              _context26.t0 = tableOrName;
              _context26.next = 7;
              break;
            case 4:
              _context26.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context26.t0 = _context26.sent;
            case 7:
              table = _context26.t0;
              oldColumn = InstanceChecker.isTableColumn(oldTableColumnOrName) ? oldTableColumnOrName : table.columns.find(function (c) {
                return c.name === oldTableColumnOrName;
              });
              if (oldColumn) {
                _context26.next = 11;
                break;
              }
              throw new TypeORMError("Column \"".concat(oldTableColumnOrName, "\" was not found in the \"").concat(table.name, "\" table."));
            case 11:
              if (InstanceChecker.isTableColumn(newTableColumnOrName)) {
                newColumn = newTableColumnOrName;
              } else {
                newColumn = oldColumn.clone();
                newColumn.name = newTableColumnOrName;
              }
              return _context26.abrupt("return", this.changeColumn(table, oldColumn, newColumn));
            case 13:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function renameColumn(_x35, _x36, _x37) {
        return _renameColumn.apply(this, arguments);
      }
      return renameColumn;
    }()
    /**
     * Changes a column in the table.
     */
  }, {
    key: "changeColumn",
    value: function () {
      var _changeColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(tableOrName, oldTableColumnOrName, newColumn) {
        var _this6 = this;
        var table, clonedTable, upQueries, downQueries, defaultValueChanged, oldColumn, oldEnumType, primaryColumns, columnNames, oldPkName, newPkName, sequencePath, sequenceName, newSequencePath, newSequenceName, up, down, oldTableColumn, arraySuffix, newEnumName, oldEnumName, oldEnumNameWithoutSchema, oldEnumNameWithSchema_old, oldEnumNameWithoutSchema_old, upType, downType, _primaryColumns, pkName, _columnNames2, column, _pkName2, _columnNames3, primaryColumn, _column2, _pkName3, _columnNames4, uniqueConstraint, _uniqueConstraint, tableNameWithSchema, tableName, schema;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context27.next = 4;
                break;
              }
              _context27.t0 = tableOrName;
              _context27.next = 7;
              break;
            case 4:
              _context27.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context27.t0 = _context27.sent;
            case 7:
              table = _context27.t0;
              clonedTable = table.clone();
              upQueries = [];
              downQueries = [];
              defaultValueChanged = false;
              oldColumn = InstanceChecker.isTableColumn(oldTableColumnOrName) ? oldTableColumnOrName : table.columns.find(function (column) {
                return column.name === oldTableColumnOrName;
              });
              if (oldColumn) {
                _context27.next = 15;
                break;
              }
              throw new TypeORMError("Column \"".concat(oldTableColumnOrName, "\" was not found in the \"").concat(table.name, "\" table."));
            case 15:
              if (!(oldColumn.type !== newColumn.type || oldColumn.length !== newColumn.length || newColumn.isArray !== oldColumn.isArray || !oldColumn.generatedType && newColumn.generatedType === "STORED" || oldColumn.asExpression !== newColumn.asExpression && newColumn.generatedType === "STORED")) {
                _context27.next = 23;
                break;
              }
              _context27.next = 18;
              return this.dropColumn(table, oldColumn);
            case 18:
              _context27.next = 20;
              return this.addColumn(table, newColumn);
            case 20:
              // update cloned table
              clonedTable = table.clone();
              _context27.next = 64;
              break;
            case 23:
              if (!(oldColumn.name !== newColumn.name)) {
                _context27.next = 40;
                break;
              }
              // rename column
              upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " RENAME COLUMN \"").concat(oldColumn.name, "\" TO \"").concat(newColumn.name, "\"")));
              downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " RENAME COLUMN \"").concat(newColumn.name, "\" TO \"").concat(oldColumn.name, "\"")));
              // rename ENUM type
              if (!(oldColumn.type === "enum" || oldColumn.type === "simple-enum")) {
                _context27.next = 32;
                break;
              }
              _context27.next = 29;
              return this.getUserDefinedTypeName(table, oldColumn);
            case 29:
              oldEnumType = _context27.sent;
              upQueries.push(new Query("ALTER TYPE \"".concat(oldEnumType.schema, "\".\"").concat(oldEnumType.name, "\" RENAME TO ").concat(this.buildEnumName(table, newColumn, false))));
              downQueries.push(new Query("ALTER TYPE ".concat(this.buildEnumName(table, newColumn), " RENAME TO \"").concat(oldEnumType.name, "\"")));
            case 32:
              // rename column primary key constraint
              if (oldColumn.isPrimary === true && !oldColumn.primaryKeyConstraintName) {
                primaryColumns = clonedTable.primaryColumns; // build old primary constraint name
                columnNames = primaryColumns.map(function (column) {
                  return column.name;
                });
                oldPkName = this.connection.namingStrategy.primaryKeyName(clonedTable, columnNames); // replace old column name with new column name
                columnNames.splice(columnNames.indexOf(oldColumn.name), 1);
                columnNames.push(newColumn.name);
                // build new primary constraint name
                newPkName = this.connection.namingStrategy.primaryKeyName(clonedTable, columnNames);
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " RENAME CONSTRAINT \"").concat(oldPkName, "\" TO \"").concat(newPkName, "\"")));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " RENAME CONSTRAINT \"").concat(newPkName, "\" TO \"").concat(oldPkName, "\"")));
              }
              // rename column sequence
              if (oldColumn.isGenerated === true && newColumn.generationStrategy === "increment") {
                sequencePath = this.buildSequencePath(table, oldColumn.name);
                sequenceName = this.buildSequenceName(table, oldColumn.name);
                newSequencePath = this.buildSequencePath(table, newColumn.name);
                newSequenceName = this.buildSequenceName(table, newColumn.name);
                up = "ALTER SEQUENCE ".concat(this.escapePath(sequencePath), " RENAME TO \"").concat(newSequenceName, "\"");
                down = "ALTER SEQUENCE ".concat(this.escapePath(newSequencePath), " RENAME TO \"").concat(sequenceName, "\"");
                upQueries.push(new Query(up));
                downQueries.push(new Query(down));
              }
              // rename unique constraints
              clonedTable.findColumnUniques(oldColumn).forEach(function (unique) {
                var oldUniqueName = _this6.connection.namingStrategy.uniqueConstraintName(clonedTable, unique.columnNames);
                // Skip renaming if Unique has user defined constraint name
                if (unique.name !== oldUniqueName) return;
                // build new constraint name
                unique.columnNames.splice(unique.columnNames.indexOf(oldColumn.name), 1);
                unique.columnNames.push(newColumn.name);
                var newUniqueName = _this6.connection.namingStrategy.uniqueConstraintName(clonedTable, unique.columnNames);
                // build queries
                upQueries.push(new Query("ALTER TABLE ".concat(_this6.escapePath(table), " RENAME CONSTRAINT \"").concat(unique.name, "\" TO \"").concat(newUniqueName, "\"")));
                downQueries.push(new Query("ALTER TABLE ".concat(_this6.escapePath(table), " RENAME CONSTRAINT \"").concat(newUniqueName, "\" TO \"").concat(unique.name, "\"")));
                // replace constraint name
                unique.name = newUniqueName;
              });
              // rename index constraints
              clonedTable.findColumnIndices(oldColumn).forEach(function (index) {
                var oldIndexName = _this6.connection.namingStrategy.indexName(clonedTable, index.columnNames, index.where);
                // Skip renaming if Index has user defined constraint name
                if (index.name !== oldIndexName) return;
                // build new constraint name
                index.columnNames.splice(index.columnNames.indexOf(oldColumn.name), 1);
                index.columnNames.push(newColumn.name);
                var _this6$driver$parseTa = _this6.driver.parseTableName(table),
                  schema = _this6$driver$parseTa.schema;
                var newIndexName = _this6.connection.namingStrategy.indexName(clonedTable, index.columnNames, index.where);
                // build queries
                var up = schema ? "ALTER INDEX \"".concat(schema, "\".\"").concat(index.name, "\" RENAME TO \"").concat(newIndexName, "\"") : "ALTER INDEX \"".concat(index.name, "\" RENAME TO \"").concat(newIndexName, "\"");
                var down = schema ? "ALTER INDEX \"".concat(schema, "\".\"").concat(newIndexName, "\" RENAME TO \"").concat(index.name, "\"") : "ALTER INDEX \"".concat(newIndexName, "\" RENAME TO \"").concat(index.name, "\"");
                upQueries.push(new Query(up));
                downQueries.push(new Query(down));
                // replace constraint name
                index.name = newIndexName;
              });
              // rename foreign key constraints
              clonedTable.findColumnForeignKeys(oldColumn).forEach(function (foreignKey) {
                var foreignKeyName = _this6.connection.namingStrategy.foreignKeyName(clonedTable, foreignKey.columnNames, _this6.getTablePath(foreignKey), foreignKey.referencedColumnNames);
                // Skip renaming if foreign key has user defined constraint name
                if (foreignKey.name !== foreignKeyName) return;
                // build new constraint name
                foreignKey.columnNames.splice(foreignKey.columnNames.indexOf(oldColumn.name), 1);
                foreignKey.columnNames.push(newColumn.name);
                var newForeignKeyName = _this6.connection.namingStrategy.foreignKeyName(clonedTable, foreignKey.columnNames, _this6.getTablePath(foreignKey), foreignKey.referencedColumnNames);
                // build queries
                upQueries.push(new Query("ALTER TABLE ".concat(_this6.escapePath(table), " RENAME CONSTRAINT \"").concat(foreignKey.name, "\" TO \"").concat(newForeignKeyName, "\"")));
                downQueries.push(new Query("ALTER TABLE ".concat(_this6.escapePath(table), " RENAME CONSTRAINT \"").concat(newForeignKeyName, "\" TO \"").concat(foreignKey.name, "\"")));
                // replace constraint name
                foreignKey.name = newForeignKeyName;
              });
              // rename old column in the Table object
              oldTableColumn = clonedTable.columns.find(function (column) {
                return column.name === oldColumn.name;
              });
              clonedTable.columns[clonedTable.columns.indexOf(oldTableColumn)].name = newColumn.name;
              oldColumn.name = newColumn.name;
            case 40:
              if (newColumn.precision !== oldColumn.precision || newColumn.scale !== oldColumn.scale) {
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" TYPE ").concat(this.driver.createFullType(newColumn))));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" TYPE ").concat(this.driver.createFullType(oldColumn))));
              }
              if ((newColumn.type === "enum" || newColumn.type === "simple-enum") && (oldColumn.type === "enum" || oldColumn.type === "simple-enum") && (!OrmUtils.isArraysEqual(newColumn.enum, oldColumn.enum) || newColumn.enumName !== oldColumn.enumName)) {
                arraySuffix = newColumn.isArray ? "[]" : ""; // "public"."new_enum"
                newEnumName = this.buildEnumName(table, newColumn); // "public"."old_enum"
                oldEnumName = this.buildEnumName(table, oldColumn); // "old_enum"
                oldEnumNameWithoutSchema = this.buildEnumName(table, oldColumn, false); //"public"."old_enum_old"
                oldEnumNameWithSchema_old = this.buildEnumName(table, oldColumn, true, false, true); //"old_enum_old"
                oldEnumNameWithoutSchema_old = this.buildEnumName(table, oldColumn, false, false, true); // rename old ENUM
                upQueries.push(new Query("ALTER TYPE ".concat(oldEnumName, " RENAME TO ").concat(oldEnumNameWithoutSchema_old)));
                downQueries.push(new Query("ALTER TYPE ".concat(oldEnumNameWithSchema_old, " RENAME TO ").concat(oldEnumNameWithoutSchema)));
                // create new ENUM
                upQueries.push(this.createEnumTypeSql(table, newColumn, newEnumName));
                downQueries.push(this.dropEnumTypeSql(table, newColumn, newEnumName));
                // if column have default value, we must drop it to avoid issues with type casting
                if (oldColumn.default !== null && oldColumn.default !== undefined) {
                  // mark default as changed to prevent double update
                  defaultValueChanged = true;
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(oldColumn.name, "\" DROP DEFAULT")));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(oldColumn.name, "\" SET DEFAULT ").concat(oldColumn.default)));
                }
                // build column types
                upType = "".concat(newEnumName).concat(arraySuffix, " USING \"").concat(newColumn.name, "\"::\"text\"::").concat(newEnumName).concat(arraySuffix);
                downType = "".concat(oldEnumNameWithSchema_old).concat(arraySuffix, " USING \"").concat(newColumn.name, "\"::\"text\"::").concat(oldEnumNameWithSchema_old).concat(arraySuffix); // update column to use new type
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" TYPE ").concat(upType)));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" TYPE ").concat(downType)));
                // restore column default or create new one
                if (newColumn.default !== null && newColumn.default !== undefined) {
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" SET DEFAULT ").concat(newColumn.default)));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" DROP DEFAULT")));
                }
                // remove old ENUM
                upQueries.push(this.dropEnumTypeSql(table, oldColumn, oldEnumNameWithSchema_old));
                downQueries.push(this.createEnumTypeSql(table, oldColumn, oldEnumNameWithSchema_old));
              }
              if (oldColumn.isNullable !== newColumn.isNullable) {
                if (newColumn.isNullable) {
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(oldColumn.name, "\" DROP NOT NULL")));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(oldColumn.name, "\" SET NOT NULL")));
                } else {
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(oldColumn.name, "\" SET NOT NULL")));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(oldColumn.name, "\" DROP NOT NULL")));
                }
              }
              if (oldColumn.comment !== newColumn.comment) {
                upQueries.push(new Query("COMMENT ON COLUMN ".concat(this.escapePath(table), ".\"").concat(oldColumn.name, "\" IS ").concat(this.escapeComment(newColumn.comment))));
                downQueries.push(new Query("COMMENT ON COLUMN ".concat(this.escapePath(table), ".\"").concat(newColumn.name, "\" IS ").concat(this.escapeComment(oldColumn.comment))));
              }
              if (newColumn.isPrimary !== oldColumn.isPrimary) {
                _primaryColumns = clonedTable.primaryColumns; // if primary column state changed, we must always drop existed constraint.
                if (_primaryColumns.length > 0) {
                  pkName = _primaryColumns[0].primaryKeyConstraintName ? _primaryColumns[0].primaryKeyConstraintName : this.connection.namingStrategy.primaryKeyName(clonedTable, _primaryColumns.map(function (column) {
                    return column.name;
                  }));
                  _columnNames2 = _primaryColumns.map(function (column) {
                    return "\"".concat(column.name, "\"");
                  }).join(", ");
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP CONSTRAINT \"").concat(pkName, "\"")));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT \"").concat(pkName, "\" PRIMARY KEY (").concat(_columnNames2, ")")));
                }
                if (newColumn.isPrimary === true) {
                  _primaryColumns.push(newColumn);
                  // update column in table
                  column = clonedTable.columns.find(function (column) {
                    return column.name === newColumn.name;
                  });
                  column.isPrimary = true;
                  _pkName2 = _primaryColumns[0].primaryKeyConstraintName ? _primaryColumns[0].primaryKeyConstraintName : this.connection.namingStrategy.primaryKeyName(clonedTable, _primaryColumns.map(function (column) {
                    return column.name;
                  }));
                  _columnNames3 = _primaryColumns.map(function (column) {
                    return "\"".concat(column.name, "\"");
                  }).join(", ");
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT \"").concat(_pkName2, "\" PRIMARY KEY (").concat(_columnNames3, ")")));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP CONSTRAINT \"").concat(_pkName2, "\"")));
                } else {
                  primaryColumn = _primaryColumns.find(function (c) {
                    return c.name === newColumn.name;
                  });
                  _primaryColumns.splice(_primaryColumns.indexOf(primaryColumn), 1);
                  // update column in table
                  _column2 = clonedTable.columns.find(function (column) {
                    return column.name === newColumn.name;
                  });
                  _column2.isPrimary = false;
                  // if we have another primary keys, we must recreate constraint.
                  if (_primaryColumns.length > 0) {
                    _pkName3 = _primaryColumns[0].primaryKeyConstraintName ? _primaryColumns[0].primaryKeyConstraintName : this.connection.namingStrategy.primaryKeyName(clonedTable, _primaryColumns.map(function (column) {
                      return column.name;
                    }));
                    _columnNames4 = _primaryColumns.map(function (column) {
                      return "\"".concat(column.name, "\"");
                    }).join(", ");
                    upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT \"").concat(_pkName3, "\" PRIMARY KEY (").concat(_columnNames4, ")")));
                    downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP CONSTRAINT \"").concat(_pkName3, "\"")));
                  }
                }
              }
              if (newColumn.isUnique !== oldColumn.isUnique) {
                if (newColumn.isUnique === true) {
                  uniqueConstraint = new TableUnique({
                    name: this.connection.namingStrategy.uniqueConstraintName(table, [newColumn.name]),
                    columnNames: [newColumn.name]
                  });
                  clonedTable.uniques.push(uniqueConstraint);
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT \"").concat(uniqueConstraint.name, "\" UNIQUE (\"").concat(newColumn.name, "\")")));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP CONSTRAINT \"").concat(uniqueConstraint.name, "\"")));
                } else {
                  _uniqueConstraint = clonedTable.uniques.find(function (unique) {
                    return unique.columnNames.length === 1 && !!unique.columnNames.find(function (columnName) {
                      return columnName === newColumn.name;
                    });
                  });
                  clonedTable.uniques.splice(clonedTable.uniques.indexOf(_uniqueConstraint), 1);
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP CONSTRAINT \"").concat(_uniqueConstraint.name, "\"")));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT \"").concat(_uniqueConstraint.name, "\" UNIQUE (\"").concat(newColumn.name, "\")")));
                }
              }
              if (oldColumn.isGenerated !== newColumn.isGenerated) {
                // if old column was "generated", we should clear defaults
                if (oldColumn.isGenerated) {
                  if (oldColumn.generationStrategy === "uuid") {
                    upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(oldColumn.name, "\" DROP DEFAULT")));
                    downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(oldColumn.name, "\" SET DEFAULT ").concat(this.driver.uuidGenerator)));
                  } else if (oldColumn.generationStrategy === "increment") {
                    upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" DROP DEFAULT")));
                    downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" SET DEFAULT nextval('").concat(this.escapePath(this.buildSequencePath(table, newColumn)), "')")));
                    upQueries.push(new Query("DROP SEQUENCE ".concat(this.escapePath(this.buildSequencePath(table, newColumn)))));
                    downQueries.push(new Query("CREATE SEQUENCE IF NOT EXISTS ".concat(this.escapePath(this.buildSequencePath(table, newColumn)), " OWNED BY ").concat(this.escapePath(table), ".\"").concat(newColumn.name, "\"")));
                  }
                }
                if (newColumn.generationStrategy === "uuid") {
                  if (newColumn.isGenerated === true) {
                    upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" SET DEFAULT ").concat(this.driver.uuidGenerator)));
                    downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" DROP DEFAULT")));
                  } else {
                    upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" DROP DEFAULT")));
                    downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" SET DEFAULT ").concat(this.driver.uuidGenerator)));
                  }
                } else if (newColumn.generationStrategy === "increment") {
                  if (newColumn.isGenerated === true) {
                    upQueries.push(new Query("CREATE SEQUENCE IF NOT EXISTS ".concat(this.escapePath(this.buildSequencePath(table, newColumn)), " OWNED BY ").concat(this.escapePath(table), ".\"").concat(newColumn.name, "\"")));
                    downQueries.push(new Query("DROP SEQUENCE ".concat(this.escapePath(this.buildSequencePath(table, newColumn)))));
                    upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" SET DEFAULT nextval('").concat(this.escapePath(this.buildSequencePath(table, newColumn)), "')")));
                    downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" DROP DEFAULT")));
                  } else {
                    upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" DROP DEFAULT")));
                    downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" SET DEFAULT nextval('").concat(this.escapePath(this.buildSequencePath(table, newColumn)), "')")));
                    upQueries.push(new Query("DROP SEQUENCE ".concat(this.escapePath(this.buildSequencePath(table, newColumn)))));
                    downQueries.push(new Query("CREATE SEQUENCE IF NOT EXISTS ".concat(this.escapePath(this.buildSequencePath(table, newColumn)), " OWNED BY ").concat(this.escapePath(table), ".\"").concat(newColumn.name, "\"")));
                  }
                }
              }
              // the default might have changed when the enum changed
              if (newColumn.default !== oldColumn.default && !defaultValueChanged) {
                if (newColumn.default !== null && newColumn.default !== undefined) {
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" SET DEFAULT ").concat(newColumn.default)));
                  if (oldColumn.default !== null && oldColumn.default !== undefined) {
                    downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" SET DEFAULT ").concat(oldColumn.default)));
                  } else {
                    downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" DROP DEFAULT")));
                  }
                } else if (oldColumn.default !== null && oldColumn.default !== undefined) {
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" DROP DEFAULT")));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" SET DEFAULT ").concat(oldColumn.default)));
                }
              }
              if ((newColumn.spatialFeatureType || "").toLowerCase() !== (oldColumn.spatialFeatureType || "").toLowerCase() || newColumn.srid !== oldColumn.srid) {
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" TYPE ").concat(this.driver.createFullType(newColumn))));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ALTER COLUMN \"").concat(newColumn.name, "\" TYPE ").concat(this.driver.createFullType(oldColumn))));
              }
              if (!(newColumn.generatedType !== oldColumn.generatedType)) {
                _context27.next = 64;
                break;
              }
              if (!(!newColumn.generatedType || newColumn.generatedType === "VIRTUAL")) {
                _context27.next = 64;
                break;
              }
              _context27.next = 53;
              return this.getTableNameWithSchema(table.name);
            case 53:
              tableNameWithSchema = _context27.sent.split(".");
              tableName = tableNameWithSchema[1];
              schema = tableNameWithSchema[0];
              upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " RENAME COLUMN \"").concat(oldColumn.name, "\" TO \"TEMP_OLD_").concat(oldColumn.name, "\"")));
              upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD ").concat(this.buildCreateColumnSql(table, newColumn))));
              upQueries.push(new Query("UPDATE ".concat(this.escapePath(table), " SET \"").concat(newColumn.name, "\" = \"TEMP_OLD_").concat(oldColumn.name, "\"")));
              upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP COLUMN \"TEMP_OLD_").concat(oldColumn.name, "\"")));
              upQueries.push(this.deleteTypeormMetadataSql({
                database: this.driver.database,
                schema: schema,
                table: tableName,
                type: MetadataTableType.GENERATED_COLUMN,
                name: oldColumn.name
              }));
              // However, we can't copy it back on downgrade. It needs to regenerate.
              downQueries.push(this.insertTypeormMetadataSql({
                database: this.driver.database,
                schema: schema,
                table: tableName,
                type: MetadataTableType.GENERATED_COLUMN,
                name: oldColumn.name,
                value: oldColumn.asExpression
              }));
              downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD ").concat(this.buildCreateColumnSql(table, oldColumn))));
              downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP COLUMN \"").concat(newColumn.name, "\"")));
              // downQueries.push(
              //     this.deleteTypeormMetadataSql({
              //         database: this.driver.database,
              //         schema,
              //         table: tableName,
              //         type: MetadataTableType.GENERATED_COLUMN,
              //         name: newColumn.name,
              //     }),
              // )
            case 64:
              _context27.next = 66;
              return this.executeQueries(upQueries, downQueries);
            case 66:
              this.replaceCachedTable(table, clonedTable);
            case 67:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
      function changeColumn(_x38, _x39, _x40) {
        return _changeColumn.apply(this, arguments);
      }
      return changeColumn;
    }()
    /**
     * Changes a column in the table.
     */
  }, {
    key: "changeColumns",
    value: function () {
      var _changeColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28(tableOrName, changedColumns) {
        var _iterator6, _step6, _step6$value, oldColumn, newColumn;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _iterator6 = _createForOfIteratorHelper(changedColumns);
              _context28.prev = 1;
              _iterator6.s();
            case 3:
              if ((_step6 = _iterator6.n()).done) {
                _context28.next = 9;
                break;
              }
              _step6$value = _step6.value, oldColumn = _step6$value.oldColumn, newColumn = _step6$value.newColumn;
              _context28.next = 7;
              return this.changeColumn(tableOrName, oldColumn, newColumn);
            case 7:
              _context28.next = 3;
              break;
            case 9:
              _context28.next = 14;
              break;
            case 11:
              _context28.prev = 11;
              _context28.t0 = _context28["catch"](1);
              _iterator6.e(_context28.t0);
            case 14:
              _context28.prev = 14;
              _iterator6.f();
              return _context28.finish(14);
            case 17:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this, [[1, 11, 14, 17]]);
      }));
      function changeColumns(_x41, _x42) {
        return _changeColumns.apply(this, arguments);
      }
      return changeColumns;
    }()
    /**
     * Drops column in the table.
     */
  }, {
    key: "dropColumn",
    value: function () {
      var _dropColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29(tableOrName, columnOrName) {
        var table, column, clonedTable, upQueries, downQueries, pkName, columnNames, tableColumn, _pkName4, _columnNames5, columnIndex, columnCheck, columnUnique, hasEnum, enumType, escapedEnumName, tableNameWithSchema, tableName, schema, deleteQuery, insertQuery;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context29.next = 4;
                break;
              }
              _context29.t0 = tableOrName;
              _context29.next = 7;
              break;
            case 4:
              _context29.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context29.t0 = _context29.sent;
            case 7:
              table = _context29.t0;
              column = InstanceChecker.isTableColumn(columnOrName) ? columnOrName : table.findColumnByName(columnOrName);
              if (column) {
                _context29.next = 11;
                break;
              }
              throw new TypeORMError("Column \"".concat(columnOrName, "\" was not found in table \"").concat(table.name, "\""));
            case 11:
              clonedTable = table.clone();
              upQueries = [];
              downQueries = []; // drop primary key constraint
              if (column.isPrimary) {
                pkName = column.primaryKeyConstraintName ? column.primaryKeyConstraintName : this.connection.namingStrategy.primaryKeyName(clonedTable, clonedTable.primaryColumns.map(function (column) {
                  return column.name;
                }));
                columnNames = clonedTable.primaryColumns.map(function (primaryColumn) {
                  return "\"".concat(primaryColumn.name, "\"");
                }).join(", ");
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(clonedTable), " DROP CONSTRAINT \"").concat(pkName, "\"")));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(clonedTable), " ADD CONSTRAINT \"").concat(pkName, "\" PRIMARY KEY (").concat(columnNames, ")")));
                // update column in table
                tableColumn = clonedTable.findColumnByName(column.name);
                tableColumn.isPrimary = false;
                // if primary key have multiple columns, we must recreate it without dropped column
                if (clonedTable.primaryColumns.length > 0) {
                  _pkName4 = clonedTable.primaryColumns[0].primaryKeyConstraintName ? clonedTable.primaryColumns[0].primaryKeyConstraintName : this.connection.namingStrategy.primaryKeyName(clonedTable, clonedTable.primaryColumns.map(function (column) {
                    return column.name;
                  }));
                  _columnNames5 = clonedTable.primaryColumns.map(function (primaryColumn) {
                    return "\"".concat(primaryColumn.name, "\"");
                  }).join(", ");
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(clonedTable), " ADD CONSTRAINT \"").concat(_pkName4, "\" PRIMARY KEY (").concat(_columnNames5, ")")));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(clonedTable), " DROP CONSTRAINT \"").concat(_pkName4, "\"")));
                }
              }
              // drop column index
              columnIndex = clonedTable.indices.find(function (index) {
                return index.columnNames.length === 1 && index.columnNames[0] === column.name;
              });
              if (columnIndex) {
                clonedTable.indices.splice(clonedTable.indices.indexOf(columnIndex), 1);
                upQueries.push(this.dropIndexSql(table, columnIndex));
                downQueries.push(this.createIndexSql(table, columnIndex));
              }
              // drop column check
              columnCheck = clonedTable.checks.find(function (check) {
                return !!check.columnNames && check.columnNames.length === 1 && check.columnNames[0] === column.name;
              });
              if (columnCheck) {
                clonedTable.checks.splice(clonedTable.checks.indexOf(columnCheck), 1);
                upQueries.push(this.dropCheckConstraintSql(table, columnCheck));
                downQueries.push(this.createCheckConstraintSql(table, columnCheck));
              }
              // drop column unique
              columnUnique = clonedTable.uniques.find(function (unique) {
                return unique.columnNames.length === 1 && unique.columnNames[0] === column.name;
              });
              if (columnUnique) {
                clonedTable.uniques.splice(clonedTable.uniques.indexOf(columnUnique), 1);
                upQueries.push(this.dropUniqueConstraintSql(table, columnUnique));
                downQueries.push(this.createUniqueConstraintSql(table, columnUnique));
              }
              upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP COLUMN \"").concat(column.name, "\"")));
              downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD ").concat(this.buildCreateColumnSql(table, column))));
              // drop enum type
              if (!(column.type === "enum" || column.type === "simple-enum")) {
                _context29.next = 34;
                break;
              }
              _context29.next = 26;
              return this.hasEnumType(table, column);
            case 26:
              hasEnum = _context29.sent;
              if (!hasEnum) {
                _context29.next = 34;
                break;
              }
              _context29.next = 30;
              return this.getUserDefinedTypeName(table, column);
            case 30:
              enumType = _context29.sent;
              escapedEnumName = "\"".concat(enumType.schema, "\".\"").concat(enumType.name, "\"");
              upQueries.push(this.dropEnumTypeSql(table, column, escapedEnumName));
              downQueries.push(this.createEnumTypeSql(table, column, escapedEnumName));
            case 34:
              if (!(column.generatedType === "STORED")) {
                _context29.next = 44;
                break;
              }
              _context29.next = 37;
              return this.getTableNameWithSchema(table.name);
            case 37:
              tableNameWithSchema = _context29.sent.split(".");
              tableName = tableNameWithSchema[1];
              schema = tableNameWithSchema[0];
              deleteQuery = this.deleteTypeormMetadataSql({
                database: this.driver.database,
                schema: schema,
                table: tableName,
                type: MetadataTableType.GENERATED_COLUMN,
                name: column.name
              });
              insertQuery = this.insertTypeormMetadataSql({
                database: this.driver.database,
                schema: schema,
                table: tableName,
                type: MetadataTableType.GENERATED_COLUMN,
                name: column.name,
                value: column.asExpression
              });
              upQueries.push(deleteQuery);
              downQueries.push(insertQuery);
            case 44:
              _context29.next = 46;
              return this.executeQueries(upQueries, downQueries);
            case 46:
              clonedTable.removeColumn(column);
              this.replaceCachedTable(table, clonedTable);
            case 48:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
      function dropColumn(_x43, _x44) {
        return _dropColumn.apply(this, arguments);
      }
      return dropColumn;
    }()
    /**
     * Drops the columns in the table.
     */
  }, {
    key: "dropColumns",
    value: function () {
      var _dropColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30(tableOrName, columns) {
        var _iterator7, _step7, column;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _iterator7 = _createForOfIteratorHelper(columns);
              _context30.prev = 1;
              _iterator7.s();
            case 3:
              if ((_step7 = _iterator7.n()).done) {
                _context30.next = 9;
                break;
              }
              column = _step7.value;
              _context30.next = 7;
              return this.dropColumn(tableOrName, column);
            case 7:
              _context30.next = 3;
              break;
            case 9:
              _context30.next = 14;
              break;
            case 11:
              _context30.prev = 11;
              _context30.t0 = _context30["catch"](1);
              _iterator7.e(_context30.t0);
            case 14:
              _context30.prev = 14;
              _iterator7.f();
              return _context30.finish(14);
            case 17:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this, [[1, 11, 14, 17]]);
      }));
      function dropColumns(_x45, _x46) {
        return _dropColumns.apply(this, arguments);
      }
      return dropColumns;
    }()
    /**
     * Creates a new primary key.
     */
  }, {
    key: "createPrimaryKey",
    value: function () {
      var _createPrimaryKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31(tableOrName, columnNames, constraintName) {
        var table, clonedTable, up, down;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context31.next = 4;
                break;
              }
              _context31.t0 = tableOrName;
              _context31.next = 7;
              break;
            case 4:
              _context31.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context31.t0 = _context31.sent;
            case 7:
              table = _context31.t0;
              clonedTable = table.clone();
              up = this.createPrimaryKeySql(table, columnNames, constraintName); // mark columns as primary, because dropPrimaryKeySql build constraint name from table primary column names.
              clonedTable.columns.forEach(function (column) {
                if (columnNames.find(function (columnName) {
                  return columnName === column.name;
                })) column.isPrimary = true;
              });
              down = this.dropPrimaryKeySql(clonedTable);
              _context31.next = 14;
              return this.executeQueries(up, down);
            case 14:
              this.replaceCachedTable(table, clonedTable);
            case 15:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this);
      }));
      function createPrimaryKey(_x47, _x48, _x49) {
        return _createPrimaryKey.apply(this, arguments);
      }
      return createPrimaryKey;
    }()
    /**
     * Updates composite primary keys.
     */
  }, {
    key: "updatePrimaryKeys",
    value: function () {
      var _updatePrimaryKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32(tableOrName, columns) {
        var _a, table, clonedTable, columnNames, upQueries, downQueries, primaryColumns, _pkName5, _columnNamesString, pkName, columnNamesString;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context32.next = 4;
                break;
              }
              _context32.t0 = tableOrName;
              _context32.next = 7;
              break;
            case 4:
              _context32.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context32.t0 = _context32.sent;
            case 7:
              table = _context32.t0;
              clonedTable = table.clone();
              columnNames = columns.map(function (column) {
                return column.name;
              });
              upQueries = [];
              downQueries = []; // if table already have primary columns, we must drop them.
              primaryColumns = clonedTable.primaryColumns;
              if (primaryColumns.length > 0) {
                _pkName5 = primaryColumns[0].primaryKeyConstraintName ? primaryColumns[0].primaryKeyConstraintName : this.connection.namingStrategy.primaryKeyName(clonedTable, primaryColumns.map(function (column) {
                  return column.name;
                }));
                _columnNamesString = primaryColumns.map(function (column) {
                  return "\"".concat(column.name, "\"");
                }).join(", ");
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP CONSTRAINT \"").concat(_pkName5, "\"")));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT \"").concat(_pkName5, "\" PRIMARY KEY (").concat(_columnNamesString, ")")));
              }
              // update columns in table.
              clonedTable.columns.filter(function (column) {
                return columnNames.indexOf(column.name) !== -1;
              }).forEach(function (column) {
                return column.isPrimary = true;
              });
              pkName = ((_a = primaryColumns[0]) === null || _a === void 0 ? void 0 : _a.primaryKeyConstraintName) ? primaryColumns[0].primaryKeyConstraintName : this.connection.namingStrategy.primaryKeyName(clonedTable, columnNames);
              columnNamesString = columnNames.map(function (columnName) {
                return "\"".concat(columnName, "\"");
              }).join(", ");
              upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT \"").concat(pkName, "\" PRIMARY KEY (").concat(columnNamesString, ")")));
              downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP CONSTRAINT \"").concat(pkName, "\"")));
              _context32.next = 21;
              return this.executeQueries(upQueries, downQueries);
            case 21:
              this.replaceCachedTable(table, clonedTable);
            case 22:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this);
      }));
      function updatePrimaryKeys(_x50, _x51) {
        return _updatePrimaryKeys.apply(this, arguments);
      }
      return updatePrimaryKeys;
    }()
    /**
     * Drops a primary key.
     */
  }, {
    key: "dropPrimaryKey",
    value: function () {
      var _dropPrimaryKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33(tableOrName, constraintName) {
        var table, up, down;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context33.next = 4;
                break;
              }
              _context33.t0 = tableOrName;
              _context33.next = 7;
              break;
            case 4:
              _context33.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context33.t0 = _context33.sent;
            case 7:
              table = _context33.t0;
              up = this.dropPrimaryKeySql(table);
              down = this.createPrimaryKeySql(table, table.primaryColumns.map(function (column) {
                return column.name;
              }), constraintName);
              _context33.next = 12;
              return this.executeQueries(up, down);
            case 12:
              table.primaryColumns.forEach(function (column) {
                column.isPrimary = false;
              });
            case 13:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this);
      }));
      function dropPrimaryKey(_x52, _x53) {
        return _dropPrimaryKey.apply(this, arguments);
      }
      return dropPrimaryKey;
    }()
    /**
     * Creates new unique constraint.
     */
  }, {
    key: "createUniqueConstraint",
    value: function () {
      var _createUniqueConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34(tableOrName, uniqueConstraint) {
        var table, up, down;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context34.next = 4;
                break;
              }
              _context34.t0 = tableOrName;
              _context34.next = 7;
              break;
            case 4:
              _context34.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context34.t0 = _context34.sent;
            case 7:
              table = _context34.t0;
              // new unique constraint may be passed without name. In this case we generate unique name manually.
              if (!uniqueConstraint.name) uniqueConstraint.name = this.connection.namingStrategy.uniqueConstraintName(table, uniqueConstraint.columnNames);
              up = this.createUniqueConstraintSql(table, uniqueConstraint);
              down = this.dropUniqueConstraintSql(table, uniqueConstraint);
              _context34.next = 13;
              return this.executeQueries(up, down);
            case 13:
              table.addUniqueConstraint(uniqueConstraint);
            case 14:
            case "end":
              return _context34.stop();
          }
        }, _callee34, this);
      }));
      function createUniqueConstraint(_x54, _x55) {
        return _createUniqueConstraint.apply(this, arguments);
      }
      return createUniqueConstraint;
    }()
    /**
     * Creates new unique constraints.
     */
  }, {
    key: "createUniqueConstraints",
    value: function () {
      var _createUniqueConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35(tableOrName, uniqueConstraints) {
        var _iterator8, _step8, uniqueConstraint;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _iterator8 = _createForOfIteratorHelper(uniqueConstraints);
              _context35.prev = 1;
              _iterator8.s();
            case 3:
              if ((_step8 = _iterator8.n()).done) {
                _context35.next = 9;
                break;
              }
              uniqueConstraint = _step8.value;
              _context35.next = 7;
              return this.createUniqueConstraint(tableOrName, uniqueConstraint);
            case 7:
              _context35.next = 3;
              break;
            case 9:
              _context35.next = 14;
              break;
            case 11:
              _context35.prev = 11;
              _context35.t0 = _context35["catch"](1);
              _iterator8.e(_context35.t0);
            case 14:
              _context35.prev = 14;
              _iterator8.f();
              return _context35.finish(14);
            case 17:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this, [[1, 11, 14, 17]]);
      }));
      function createUniqueConstraints(_x56, _x57) {
        return _createUniqueConstraints.apply(this, arguments);
      }
      return createUniqueConstraints;
    }()
    /**
     * Drops unique constraint.
     */
  }, {
    key: "dropUniqueConstraint",
    value: function () {
      var _dropUniqueConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36(tableOrName, uniqueOrName) {
        var table, uniqueConstraint, up, down;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context36.next = 4;
                break;
              }
              _context36.t0 = tableOrName;
              _context36.next = 7;
              break;
            case 4:
              _context36.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context36.t0 = _context36.sent;
            case 7:
              table = _context36.t0;
              uniqueConstraint = InstanceChecker.isTableUnique(uniqueOrName) ? uniqueOrName : table.uniques.find(function (u) {
                return u.name === uniqueOrName;
              });
              if (uniqueConstraint) {
                _context36.next = 11;
                break;
              }
              throw new TypeORMError("Supplied unique constraint was not found in table ".concat(table.name));
            case 11:
              up = this.dropUniqueConstraintSql(table, uniqueConstraint);
              down = this.createUniqueConstraintSql(table, uniqueConstraint);
              _context36.next = 15;
              return this.executeQueries(up, down);
            case 15:
              table.removeUniqueConstraint(uniqueConstraint);
            case 16:
            case "end":
              return _context36.stop();
          }
        }, _callee36, this);
      }));
      function dropUniqueConstraint(_x58, _x59) {
        return _dropUniqueConstraint.apply(this, arguments);
      }
      return dropUniqueConstraint;
    }()
    /**
     * Drops unique constraints.
     */
  }, {
    key: "dropUniqueConstraints",
    value: function () {
      var _dropUniqueConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37(tableOrName, uniqueConstraints) {
        var _iterator9, _step9, uniqueConstraint;
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              _iterator9 = _createForOfIteratorHelper(uniqueConstraints);
              _context37.prev = 1;
              _iterator9.s();
            case 3:
              if ((_step9 = _iterator9.n()).done) {
                _context37.next = 9;
                break;
              }
              uniqueConstraint = _step9.value;
              _context37.next = 7;
              return this.dropUniqueConstraint(tableOrName, uniqueConstraint);
            case 7:
              _context37.next = 3;
              break;
            case 9:
              _context37.next = 14;
              break;
            case 11:
              _context37.prev = 11;
              _context37.t0 = _context37["catch"](1);
              _iterator9.e(_context37.t0);
            case 14:
              _context37.prev = 14;
              _iterator9.f();
              return _context37.finish(14);
            case 17:
            case "end":
              return _context37.stop();
          }
        }, _callee37, this, [[1, 11, 14, 17]]);
      }));
      function dropUniqueConstraints(_x60, _x61) {
        return _dropUniqueConstraints.apply(this, arguments);
      }
      return dropUniqueConstraints;
    }()
    /**
     * Creates new check constraint.
     */
  }, {
    key: "createCheckConstraint",
    value: function () {
      var _createCheckConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee38(tableOrName, checkConstraint) {
        var table, up, down;
        return _regeneratorRuntime().wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context38.next = 4;
                break;
              }
              _context38.t0 = tableOrName;
              _context38.next = 7;
              break;
            case 4:
              _context38.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context38.t0 = _context38.sent;
            case 7:
              table = _context38.t0;
              // new unique constraint may be passed without name. In this case we generate unique name manually.
              if (!checkConstraint.name) checkConstraint.name = this.connection.namingStrategy.checkConstraintName(table, checkConstraint.expression);
              up = this.createCheckConstraintSql(table, checkConstraint);
              down = this.dropCheckConstraintSql(table, checkConstraint);
              _context38.next = 13;
              return this.executeQueries(up, down);
            case 13:
              table.addCheckConstraint(checkConstraint);
            case 14:
            case "end":
              return _context38.stop();
          }
        }, _callee38, this);
      }));
      function createCheckConstraint(_x62, _x63) {
        return _createCheckConstraint.apply(this, arguments);
      }
      return createCheckConstraint;
    }()
    /**
     * Creates new check constraints.
     */
  }, {
    key: "createCheckConstraints",
    value: function () {
      var _createCheckConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee39(tableOrName, checkConstraints) {
        var _this7 = this;
        var promises;
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              promises = checkConstraints.map(function (checkConstraint) {
                return _this7.createCheckConstraint(tableOrName, checkConstraint);
              });
              _context39.next = 3;
              return Promise.all(promises);
            case 3:
            case "end":
              return _context39.stop();
          }
        }, _callee39);
      }));
      function createCheckConstraints(_x64, _x65) {
        return _createCheckConstraints.apply(this, arguments);
      }
      return createCheckConstraints;
    }()
    /**
     * Drops check constraint.
     */
  }, {
    key: "dropCheckConstraint",
    value: function () {
      var _dropCheckConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee40(tableOrName, checkOrName) {
        var table, checkConstraint, up, down;
        return _regeneratorRuntime().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context40.next = 4;
                break;
              }
              _context40.t0 = tableOrName;
              _context40.next = 7;
              break;
            case 4:
              _context40.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context40.t0 = _context40.sent;
            case 7:
              table = _context40.t0;
              checkConstraint = InstanceChecker.isTableCheck(checkOrName) ? checkOrName : table.checks.find(function (c) {
                return c.name === checkOrName;
              });
              if (checkConstraint) {
                _context40.next = 11;
                break;
              }
              throw new TypeORMError("Supplied check constraint was not found in table ".concat(table.name));
            case 11:
              up = this.dropCheckConstraintSql(table, checkConstraint);
              down = this.createCheckConstraintSql(table, checkConstraint);
              _context40.next = 15;
              return this.executeQueries(up, down);
            case 15:
              table.removeCheckConstraint(checkConstraint);
            case 16:
            case "end":
              return _context40.stop();
          }
        }, _callee40, this);
      }));
      function dropCheckConstraint(_x66, _x67) {
        return _dropCheckConstraint.apply(this, arguments);
      }
      return dropCheckConstraint;
    }()
    /**
     * Drops check constraints.
     */
  }, {
    key: "dropCheckConstraints",
    value: function () {
      var _dropCheckConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee41(tableOrName, checkConstraints) {
        var _this8 = this;
        var promises;
        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              promises = checkConstraints.map(function (checkConstraint) {
                return _this8.dropCheckConstraint(tableOrName, checkConstraint);
              });
              _context41.next = 3;
              return Promise.all(promises);
            case 3:
            case "end":
              return _context41.stop();
          }
        }, _callee41);
      }));
      function dropCheckConstraints(_x68, _x69) {
        return _dropCheckConstraints.apply(this, arguments);
      }
      return dropCheckConstraints;
    }()
    /**
     * Creates new exclusion constraint.
     */
  }, {
    key: "createExclusionConstraint",
    value: function () {
      var _createExclusionConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee42(tableOrName, exclusionConstraint) {
        var table, up, down;
        return _regeneratorRuntime().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context42.next = 4;
                break;
              }
              _context42.t0 = tableOrName;
              _context42.next = 7;
              break;
            case 4:
              _context42.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context42.t0 = _context42.sent;
            case 7:
              table = _context42.t0;
              // new unique constraint may be passed without name. In this case we generate unique name manually.
              if (!exclusionConstraint.name) exclusionConstraint.name = this.connection.namingStrategy.exclusionConstraintName(table, exclusionConstraint.expression);
              up = this.createExclusionConstraintSql(table, exclusionConstraint);
              down = this.dropExclusionConstraintSql(table, exclusionConstraint);
              _context42.next = 13;
              return this.executeQueries(up, down);
            case 13:
              table.addExclusionConstraint(exclusionConstraint);
            case 14:
            case "end":
              return _context42.stop();
          }
        }, _callee42, this);
      }));
      function createExclusionConstraint(_x70, _x71) {
        return _createExclusionConstraint.apply(this, arguments);
      }
      return createExclusionConstraint;
    }()
    /**
     * Creates new exclusion constraints.
     */
  }, {
    key: "createExclusionConstraints",
    value: function () {
      var _createExclusionConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee43(tableOrName, exclusionConstraints) {
        var _this9 = this;
        var promises;
        return _regeneratorRuntime().wrap(function _callee43$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              promises = exclusionConstraints.map(function (exclusionConstraint) {
                return _this9.createExclusionConstraint(tableOrName, exclusionConstraint);
              });
              _context43.next = 3;
              return Promise.all(promises);
            case 3:
            case "end":
              return _context43.stop();
          }
        }, _callee43);
      }));
      function createExclusionConstraints(_x72, _x73) {
        return _createExclusionConstraints.apply(this, arguments);
      }
      return createExclusionConstraints;
    }()
    /**
     * Drops exclusion constraint.
     */
  }, {
    key: "dropExclusionConstraint",
    value: function () {
      var _dropExclusionConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee44(tableOrName, exclusionOrName) {
        var table, exclusionConstraint, up, down;
        return _regeneratorRuntime().wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context44.next = 4;
                break;
              }
              _context44.t0 = tableOrName;
              _context44.next = 7;
              break;
            case 4:
              _context44.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context44.t0 = _context44.sent;
            case 7:
              table = _context44.t0;
              exclusionConstraint = InstanceChecker.isTableExclusion(exclusionOrName) ? exclusionOrName : table.exclusions.find(function (c) {
                return c.name === exclusionOrName;
              });
              if (exclusionConstraint) {
                _context44.next = 11;
                break;
              }
              throw new TypeORMError("Supplied exclusion constraint was not found in table ".concat(table.name));
            case 11:
              up = this.dropExclusionConstraintSql(table, exclusionConstraint);
              down = this.createExclusionConstraintSql(table, exclusionConstraint);
              _context44.next = 15;
              return this.executeQueries(up, down);
            case 15:
              table.removeExclusionConstraint(exclusionConstraint);
            case 16:
            case "end":
              return _context44.stop();
          }
        }, _callee44, this);
      }));
      function dropExclusionConstraint(_x74, _x75) {
        return _dropExclusionConstraint.apply(this, arguments);
      }
      return dropExclusionConstraint;
    }()
    /**
     * Drops exclusion constraints.
     */
  }, {
    key: "dropExclusionConstraints",
    value: function () {
      var _dropExclusionConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee45(tableOrName, exclusionConstraints) {
        var _this10 = this;
        var promises;
        return _regeneratorRuntime().wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              promises = exclusionConstraints.map(function (exclusionConstraint) {
                return _this10.dropExclusionConstraint(tableOrName, exclusionConstraint);
              });
              _context45.next = 3;
              return Promise.all(promises);
            case 3:
            case "end":
              return _context45.stop();
          }
        }, _callee45);
      }));
      function dropExclusionConstraints(_x76, _x77) {
        return _dropExclusionConstraints.apply(this, arguments);
      }
      return dropExclusionConstraints;
    }()
    /**
     * Creates a new foreign key.
     */
  }, {
    key: "createForeignKey",
    value: function () {
      var _createForeignKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee46(tableOrName, foreignKey) {
        var table, up, down;
        return _regeneratorRuntime().wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context46.next = 4;
                break;
              }
              _context46.t0 = tableOrName;
              _context46.next = 7;
              break;
            case 4:
              _context46.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context46.t0 = _context46.sent;
            case 7:
              table = _context46.t0;
              // new FK may be passed without name. In this case we generate FK name manually.
              if (!foreignKey.name) foreignKey.name = this.connection.namingStrategy.foreignKeyName(table, foreignKey.columnNames, this.getTablePath(foreignKey), foreignKey.referencedColumnNames);
              up = this.createForeignKeySql(table, foreignKey);
              down = this.dropForeignKeySql(table, foreignKey);
              _context46.next = 13;
              return this.executeQueries(up, down);
            case 13:
              table.addForeignKey(foreignKey);
            case 14:
            case "end":
              return _context46.stop();
          }
        }, _callee46, this);
      }));
      function createForeignKey(_x78, _x79) {
        return _createForeignKey.apply(this, arguments);
      }
      return createForeignKey;
    }()
    /**
     * Creates a new foreign keys.
     */
  }, {
    key: "createForeignKeys",
    value: function () {
      var _createForeignKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee47(tableOrName, foreignKeys) {
        var _iterator10, _step10, foreignKey;
        return _regeneratorRuntime().wrap(function _callee47$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              _iterator10 = _createForOfIteratorHelper(foreignKeys);
              _context47.prev = 1;
              _iterator10.s();
            case 3:
              if ((_step10 = _iterator10.n()).done) {
                _context47.next = 9;
                break;
              }
              foreignKey = _step10.value;
              _context47.next = 7;
              return this.createForeignKey(tableOrName, foreignKey);
            case 7:
              _context47.next = 3;
              break;
            case 9:
              _context47.next = 14;
              break;
            case 11:
              _context47.prev = 11;
              _context47.t0 = _context47["catch"](1);
              _iterator10.e(_context47.t0);
            case 14:
              _context47.prev = 14;
              _iterator10.f();
              return _context47.finish(14);
            case 17:
            case "end":
              return _context47.stop();
          }
        }, _callee47, this, [[1, 11, 14, 17]]);
      }));
      function createForeignKeys(_x80, _x81) {
        return _createForeignKeys.apply(this, arguments);
      }
      return createForeignKeys;
    }()
    /**
     * Drops a foreign key from the table.
     */
  }, {
    key: "dropForeignKey",
    value: function () {
      var _dropForeignKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee48(tableOrName, foreignKeyOrName) {
        var table, foreignKey, up, down;
        return _regeneratorRuntime().wrap(function _callee48$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context48.next = 4;
                break;
              }
              _context48.t0 = tableOrName;
              _context48.next = 7;
              break;
            case 4:
              _context48.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context48.t0 = _context48.sent;
            case 7:
              table = _context48.t0;
              foreignKey = InstanceChecker.isTableForeignKey(foreignKeyOrName) ? foreignKeyOrName : table.foreignKeys.find(function (fk) {
                return fk.name === foreignKeyOrName;
              });
              if (foreignKey) {
                _context48.next = 11;
                break;
              }
              throw new TypeORMError("Supplied foreign key was not found in table ".concat(table.name));
            case 11:
              if (!foreignKey.name) {
                foreignKey.name = this.connection.namingStrategy.foreignKeyName(table, foreignKey.columnNames, this.getTablePath(foreignKey), foreignKey.referencedColumnNames);
              }
              up = this.dropForeignKeySql(table, foreignKey);
              down = this.createForeignKeySql(table, foreignKey);
              _context48.next = 16;
              return this.executeQueries(up, down);
            case 16:
              table.removeForeignKey(foreignKey);
            case 17:
            case "end":
              return _context48.stop();
          }
        }, _callee48, this);
      }));
      function dropForeignKey(_x82, _x83) {
        return _dropForeignKey.apply(this, arguments);
      }
      return dropForeignKey;
    }()
    /**
     * Drops a foreign keys from the table.
     */
  }, {
    key: "dropForeignKeys",
    value: function () {
      var _dropForeignKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee49(tableOrName, foreignKeys) {
        var _iterator11, _step11, foreignKey;
        return _regeneratorRuntime().wrap(function _callee49$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              _iterator11 = _createForOfIteratorHelper(foreignKeys);
              _context49.prev = 1;
              _iterator11.s();
            case 3:
              if ((_step11 = _iterator11.n()).done) {
                _context49.next = 9;
                break;
              }
              foreignKey = _step11.value;
              _context49.next = 7;
              return this.dropForeignKey(tableOrName, foreignKey);
            case 7:
              _context49.next = 3;
              break;
            case 9:
              _context49.next = 14;
              break;
            case 11:
              _context49.prev = 11;
              _context49.t0 = _context49["catch"](1);
              _iterator11.e(_context49.t0);
            case 14:
              _context49.prev = 14;
              _iterator11.f();
              return _context49.finish(14);
            case 17:
            case "end":
              return _context49.stop();
          }
        }, _callee49, this, [[1, 11, 14, 17]]);
      }));
      function dropForeignKeys(_x84, _x85) {
        return _dropForeignKeys.apply(this, arguments);
      }
      return dropForeignKeys;
    }()
    /**
     * Creates a new index.
     */
  }, {
    key: "createIndex",
    value: function () {
      var _createIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee50(tableOrName, index) {
        var table, up, down;
        return _regeneratorRuntime().wrap(function _callee50$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context50.next = 4;
                break;
              }
              _context50.t0 = tableOrName;
              _context50.next = 7;
              break;
            case 4:
              _context50.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context50.t0 = _context50.sent;
            case 7:
              table = _context50.t0;
              // new index may be passed without name. In this case we generate index name manually.
              if (!index.name) index.name = this.generateIndexName(table, index);
              up = this.createIndexSql(table, index);
              down = this.dropIndexSql(table, index);
              _context50.next = 13;
              return this.executeQueries(up, down);
            case 13:
              table.addIndex(index);
            case 14:
            case "end":
              return _context50.stop();
          }
        }, _callee50, this);
      }));
      function createIndex(_x86, _x87) {
        return _createIndex.apply(this, arguments);
      }
      return createIndex;
    }()
    /**
     * Create a new view index.
     */
  }, {
    key: "createViewIndex",
    value: function () {
      var _createViewIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee51(viewOrName, index) {
        var view, up, down;
        return _regeneratorRuntime().wrap(function _callee51$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              if (!InstanceChecker.isView(viewOrName)) {
                _context51.next = 4;
                break;
              }
              _context51.t0 = viewOrName;
              _context51.next = 7;
              break;
            case 4:
              _context51.next = 6;
              return this.getCachedView(viewOrName);
            case 6:
              _context51.t0 = _context51.sent;
            case 7:
              view = _context51.t0;
              // new index may be passed without name. In this case we generate index name manually.
              if (!index.name) index.name = this.generateIndexName(view, index);
              up = this.createViewIndexSql(view, index);
              down = this.dropIndexSql(view, index);
              _context51.next = 13;
              return this.executeQueries(up, down);
            case 13:
              view.addIndex(index);
            case 14:
            case "end":
              return _context51.stop();
          }
        }, _callee51, this);
      }));
      function createViewIndex(_x88, _x89) {
        return _createViewIndex.apply(this, arguments);
      }
      return createViewIndex;
    }()
    /**
     * Creates a new indices
     */
  }, {
    key: "createIndices",
    value: function () {
      var _createIndices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee52(tableOrName, indices) {
        var _iterator12, _step12, index;
        return _regeneratorRuntime().wrap(function _callee52$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              _iterator12 = _createForOfIteratorHelper(indices);
              _context52.prev = 1;
              _iterator12.s();
            case 3:
              if ((_step12 = _iterator12.n()).done) {
                _context52.next = 9;
                break;
              }
              index = _step12.value;
              _context52.next = 7;
              return this.createIndex(tableOrName, index);
            case 7:
              _context52.next = 3;
              break;
            case 9:
              _context52.next = 14;
              break;
            case 11:
              _context52.prev = 11;
              _context52.t0 = _context52["catch"](1);
              _iterator12.e(_context52.t0);
            case 14:
              _context52.prev = 14;
              _iterator12.f();
              return _context52.finish(14);
            case 17:
            case "end":
              return _context52.stop();
          }
        }, _callee52, this, [[1, 11, 14, 17]]);
      }));
      function createIndices(_x90, _x91) {
        return _createIndices.apply(this, arguments);
      }
      return createIndices;
    }()
    /**
     * Creates new view indices
     */
  }, {
    key: "createViewIndices",
    value: function () {
      var _createViewIndices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee53(viewOrName, indices) {
        var _iterator13, _step13, index;
        return _regeneratorRuntime().wrap(function _callee53$(_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              _iterator13 = _createForOfIteratorHelper(indices);
              _context53.prev = 1;
              _iterator13.s();
            case 3:
              if ((_step13 = _iterator13.n()).done) {
                _context53.next = 9;
                break;
              }
              index = _step13.value;
              _context53.next = 7;
              return this.createViewIndex(viewOrName, index);
            case 7:
              _context53.next = 3;
              break;
            case 9:
              _context53.next = 14;
              break;
            case 11:
              _context53.prev = 11;
              _context53.t0 = _context53["catch"](1);
              _iterator13.e(_context53.t0);
            case 14:
              _context53.prev = 14;
              _iterator13.f();
              return _context53.finish(14);
            case 17:
            case "end":
              return _context53.stop();
          }
        }, _callee53, this, [[1, 11, 14, 17]]);
      }));
      function createViewIndices(_x92, _x93) {
        return _createViewIndices.apply(this, arguments);
      }
      return createViewIndices;
    }()
    /**
     * Drops an index from the table.
     */
  }, {
    key: "dropIndex",
    value: function () {
      var _dropIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee54(tableOrName, indexOrName) {
        var table, index, up, down;
        return _regeneratorRuntime().wrap(function _callee54$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context54.next = 4;
                break;
              }
              _context54.t0 = tableOrName;
              _context54.next = 7;
              break;
            case 4:
              _context54.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context54.t0 = _context54.sent;
            case 7:
              table = _context54.t0;
              index = InstanceChecker.isTableIndex(indexOrName) ? indexOrName : table.indices.find(function (i) {
                return i.name === indexOrName;
              });
              if (index) {
                _context54.next = 11;
                break;
              }
              throw new TypeORMError("Supplied index ".concat(indexOrName, " was not found in table ").concat(table.name));
            case 11:
              // old index may be passed without name. In this case we generate index name manually.
              if (!index.name) index.name = this.generateIndexName(table, index);
              up = this.dropIndexSql(table, index);
              down = this.createIndexSql(table, index);
              _context54.next = 16;
              return this.executeQueries(up, down);
            case 16:
              table.removeIndex(index);
            case 17:
            case "end":
              return _context54.stop();
          }
        }, _callee54, this);
      }));
      function dropIndex(_x94, _x95) {
        return _dropIndex.apply(this, arguments);
      }
      return dropIndex;
    }()
    /**
     * Drops an index from a view.
     */
  }, {
    key: "dropViewIndex",
    value: function () {
      var _dropViewIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee55(viewOrName, indexOrName) {
        var view, index, up, down;
        return _regeneratorRuntime().wrap(function _callee55$(_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              if (!InstanceChecker.isView(viewOrName)) {
                _context55.next = 4;
                break;
              }
              _context55.t0 = viewOrName;
              _context55.next = 7;
              break;
            case 4:
              _context55.next = 6;
              return this.getCachedView(viewOrName);
            case 6:
              _context55.t0 = _context55.sent;
            case 7:
              view = _context55.t0;
              index = InstanceChecker.isTableIndex(indexOrName) ? indexOrName : view.indices.find(function (i) {
                return i.name === indexOrName;
              });
              if (index) {
                _context55.next = 11;
                break;
              }
              throw new TypeORMError("Supplied index ".concat(indexOrName, " was not found in view ").concat(view.name));
            case 11:
              // old index may be passed without name. In this case we generate index name manually.
              if (!index.name) index.name = this.generateIndexName(view, index);
              up = this.dropIndexSql(view, index);
              down = this.createViewIndexSql(view, index);
              _context55.next = 16;
              return this.executeQueries(up, down);
            case 16:
              view.removeIndex(index);
            case 17:
            case "end":
              return _context55.stop();
          }
        }, _callee55, this);
      }));
      function dropViewIndex(_x96, _x97) {
        return _dropViewIndex.apply(this, arguments);
      }
      return dropViewIndex;
    }()
    /**
     * Drops an indices from the table.
     */
  }, {
    key: "dropIndices",
    value: function () {
      var _dropIndices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee56(tableOrName, indices) {
        var _iterator14, _step14, index;
        return _regeneratorRuntime().wrap(function _callee56$(_context56) {
          while (1) switch (_context56.prev = _context56.next) {
            case 0:
              _iterator14 = _createForOfIteratorHelper(indices);
              _context56.prev = 1;
              _iterator14.s();
            case 3:
              if ((_step14 = _iterator14.n()).done) {
                _context56.next = 9;
                break;
              }
              index = _step14.value;
              _context56.next = 7;
              return this.dropIndex(tableOrName, index);
            case 7:
              _context56.next = 3;
              break;
            case 9:
              _context56.next = 14;
              break;
            case 11:
              _context56.prev = 11;
              _context56.t0 = _context56["catch"](1);
              _iterator14.e(_context56.t0);
            case 14:
              _context56.prev = 14;
              _iterator14.f();
              return _context56.finish(14);
            case 17:
            case "end":
              return _context56.stop();
          }
        }, _callee56, this, [[1, 11, 14, 17]]);
      }));
      function dropIndices(_x98, _x99) {
        return _dropIndices.apply(this, arguments);
      }
      return dropIndices;
    }()
    /**
     * Clears all table contents.
     * Note: this operation uses SQL's TRUNCATE query which cannot be reverted in transactions.
     */
  }, {
    key: "clearTable",
    value: function () {
      var _clearTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee57(tableName) {
        return _regeneratorRuntime().wrap(function _callee57$(_context57) {
          while (1) switch (_context57.prev = _context57.next) {
            case 0:
              _context57.next = 2;
              return this.query("TRUNCATE TABLE ".concat(this.escapePath(tableName)));
            case 2:
            case "end":
              return _context57.stop();
          }
        }, _callee57, this);
      }));
      function clearTable(_x100) {
        return _clearTable.apply(this, arguments);
      }
      return clearTable;
    }()
    /**
     * Removes all tables from the currently connected database.
     */
  }, {
    key: "clearDatabase",
    value: function () {
      var _clearDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee58() {
        var _this11 = this;
        var schemas, schemaNamesString, isAnotherTransactionActive, version, selectViewDropsQuery, dropViewQueries, selectMatViewDropsQuery, dropMatViewQueries, selectTableDropsQuery, dropTableQueries;
        return _regeneratorRuntime().wrap(function _callee58$(_context58) {
          while (1) switch (_context58.prev = _context58.next) {
            case 0:
              schemas = [];
              this.connection.entityMetadatas.filter(function (metadata) {
                return metadata.schema;
              }).forEach(function (metadata) {
                var isSchemaExist = !!schemas.find(function (schema) {
                  return schema === metadata.schema;
                });
                if (!isSchemaExist) schemas.push(metadata.schema);
              });
              schemas.push(this.driver.options.schema || "current_schema()");
              schemaNamesString = schemas.map(function (name) {
                return name === "current_schema()" ? name : "'" + name + "'";
              }).join(", ");
              isAnotherTransactionActive = this.isTransactionActive;
              if (isAnotherTransactionActive) {
                _context58.next = 8;
                break;
              }
              _context58.next = 8;
              return this.startTransaction();
            case 8:
              _context58.prev = 8;
              _context58.next = 11;
              return this.getVersion();
            case 11:
              version = _context58.sent;
              // drop views
              selectViewDropsQuery = "SELECT 'DROP VIEW IF EXISTS \"' || schemaname || '\".\"' || viewname || '\" CASCADE;' as \"query\" " + "FROM \"pg_views\" WHERE \"schemaname\" IN (".concat(schemaNamesString, ") AND \"viewname\" NOT IN ('geography_columns', 'geometry_columns', 'raster_columns', 'raster_overviews')");
              _context58.next = 15;
              return this.query(selectViewDropsQuery);
            case 15:
              dropViewQueries = _context58.sent;
              _context58.next = 18;
              return Promise.all(dropViewQueries.map(function (q) {
                return _this11.query(q["query"]);
              }));
            case 18:
              if (!VersionUtils.isGreaterOrEqual(version, "9.3")) {
                _context58.next = 25;
                break;
              }
              selectMatViewDropsQuery = "SELECT 'DROP MATERIALIZED VIEW IF EXISTS \"' || schemaname || '\".\"' || matviewname || '\" CASCADE;' as \"query\" " + "FROM \"pg_matviews\" WHERE \"schemaname\" IN (".concat(schemaNamesString, ")");
              _context58.next = 22;
              return this.query(selectMatViewDropsQuery);
            case 22:
              dropMatViewQueries = _context58.sent;
              _context58.next = 25;
              return Promise.all(dropMatViewQueries.map(function (q) {
                return _this11.query(q["query"]);
              }));
            case 25:
              // ignore spatial_ref_sys; it's a special table supporting PostGIS
              // TODO generalize this as this.driver.ignoreTables
              // drop tables
              selectTableDropsQuery = "SELECT 'DROP TABLE IF EXISTS \"' || schemaname || '\".\"' || tablename || '\" CASCADE;' as \"query\" FROM \"pg_tables\" WHERE \"schemaname\" IN (".concat(schemaNamesString, ") AND \"tablename\" NOT IN ('spatial_ref_sys')");
              _context58.next = 28;
              return this.query(selectTableDropsQuery);
            case 28:
              dropTableQueries = _context58.sent;
              _context58.next = 31;
              return Promise.all(dropTableQueries.map(function (q) {
                return _this11.query(q["query"]);
              }));
            case 31:
              _context58.next = 33;
              return this.dropEnumTypes(schemaNamesString);
            case 33:
              if (isAnotherTransactionActive) {
                _context58.next = 36;
                break;
              }
              _context58.next = 36;
              return this.commitTransaction();
            case 36:
              _context58.next = 49;
              break;
            case 38:
              _context58.prev = 38;
              _context58.t0 = _context58["catch"](8);
              _context58.prev = 40;
              if (isAnotherTransactionActive) {
                _context58.next = 44;
                break;
              }
              _context58.next = 44;
              return this.rollbackTransaction();
            case 44:
              _context58.next = 48;
              break;
            case 46:
              _context58.prev = 46;
              _context58.t1 = _context58["catch"](40);
            case 48:
              throw _context58.t0;
            case 49:
            case "end":
              return _context58.stop();
          }
        }, _callee58, this, [[8, 38], [40, 46]]);
      }));
      function clearDatabase() {
        return _clearDatabase.apply(this, arguments);
      }
      return clearDatabase;
    }() // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
  }, {
    key: "loadViews",
    value: function () {
      var _loadViews = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee59(viewNames) {
        var _this12 = this;
        var hasTable, currentDatabase, currentSchema, viewsCondition, constraintsCondition, indicesSql, query, dbViews, dbIndices;
        return _regeneratorRuntime().wrap(function _callee59$(_context59) {
          while (1) switch (_context59.prev = _context59.next) {
            case 0:
              _context59.next = 2;
              return this.hasTable(this.getTypeormMetadataTableName());
            case 2:
              hasTable = _context59.sent;
              if (hasTable) {
                _context59.next = 5;
                break;
              }
              return _context59.abrupt("return", []);
            case 5:
              if (!viewNames) {
                viewNames = [];
              }
              _context59.next = 8;
              return this.getCurrentDatabase();
            case 8:
              currentDatabase = _context59.sent;
              _context59.next = 11;
              return this.getCurrentSchema();
            case 11:
              currentSchema = _context59.sent;
              viewsCondition = viewNames.length === 0 ? "1=1" : viewNames.map(function (tableName) {
                return _this12.driver.parseTableName(tableName);
              }).map(function (_ref5) {
                var schema = _ref5.schema,
                  tableName = _ref5.tableName;
                if (!schema) {
                  schema = _this12.driver.options.schema || currentSchema;
                }
                return "(\"t\".\"schema\" = '".concat(schema, "' AND \"t\".\"name\" = '").concat(tableName, "')");
              }).join(" OR ");
              constraintsCondition = viewNames.length === 0 ? "1=1" : viewNames.map(function (tableName) {
                return _this12.driver.parseTableName(tableName);
              }).map(function (_ref6) {
                var schema = _ref6.schema,
                  tableName = _ref6.tableName;
                if (!schema) {
                  schema = _this12.driver.options.schema || currentSchema;
                }
                return "(\"ns\".\"nspname\" = '".concat(schema, "' AND \"t\".\"relname\" = '").concat(tableName, "')");
              }).join(" OR ");
              indicesSql = "SELECT \"ns\".\"nspname\" AS \"table_schema\", \"t\".\"relname\" AS \"table_name\", \"i\".\"relname\" AS \"constraint_name\", \"a\".\"attname\" AS \"column_name\", " + "CASE \"ix\".\"indisunique\" WHEN 't' THEN 'TRUE' ELSE'FALSE' END AS \"is_unique\", pg_get_expr(\"ix\".\"indpred\", \"ix\".\"indrelid\") AS \"condition\", " + "\"types\".\"typname\" AS \"type_name\" " + "FROM \"pg_class\" \"t\" " + "INNER JOIN \"pg_index\" \"ix\" ON \"ix\".\"indrelid\" = \"t\".\"oid\" " + "INNER JOIN \"pg_attribute\" \"a\" ON \"a\".\"attrelid\" = \"t\".\"oid\"  AND \"a\".\"attnum\" = ANY (\"ix\".\"indkey\") " + "INNER JOIN \"pg_namespace\" \"ns\" ON \"ns\".\"oid\" = \"t\".\"relnamespace\" " + "INNER JOIN \"pg_class\" \"i\" ON \"i\".\"oid\" = \"ix\".\"indexrelid\" " + "INNER JOIN \"pg_type\" \"types\" ON \"types\".\"oid\" = \"a\".\"atttypid\" " + "LEFT JOIN \"pg_constraint\" \"cnst\" ON \"cnst\".\"conname\" = \"i\".\"relname\" " + "WHERE \"t\".\"relkind\" IN ('m') AND \"cnst\".\"contype\" IS NULL AND (".concat(constraintsCondition, ")");
              query = "SELECT \"t\".* FROM ".concat(this.escapePath(this.getTypeormMetadataTableName()), " \"t\" ") + "INNER JOIN \"pg_catalog\".\"pg_class\" \"c\" ON \"c\".\"relname\" = \"t\".\"name\" " + "INNER JOIN \"pg_namespace\" \"n\" ON \"n\".\"oid\" = \"c\".\"relnamespace\" AND \"n\".\"nspname\" = \"t\".\"schema\" " + "WHERE \"t\".\"type\" IN ('".concat(MetadataTableType.VIEW, "', '").concat(MetadataTableType.MATERIALIZED_VIEW, "') ").concat(viewsCondition ? "AND (".concat(viewsCondition, ")") : "");
              _context59.next = 18;
              return this.query(query);
            case 18:
              dbViews = _context59.sent;
              _context59.next = 21;
              return this.query(indicesSql);
            case 21:
              dbIndices = _context59.sent;
              return _context59.abrupt("return", dbViews.map(function (dbView) {
                // find index constraints of table, group them by constraint name and build TableIndex.
                var tableIndexConstraints = OrmUtils.uniq(dbIndices.filter(function (dbIndex) {
                  return dbIndex["table_name"] === dbView["name"] && dbIndex["table_schema"] === dbView["schema"];
                }), function (dbIndex) {
                  return dbIndex["constraint_name"];
                });
                var view = new View();
                var schema = dbView["schema"] === currentSchema && !_this12.driver.options.schema ? undefined : dbView["schema"];
                view.database = currentDatabase;
                view.schema = dbView["schema"];
                view.name = _this12.driver.buildTableName(dbView["name"], schema);
                view.expression = dbView["value"];
                view.materialized = dbView["type"] === MetadataTableType.MATERIALIZED_VIEW;
                view.indices = tableIndexConstraints.map(function (constraint) {
                  var indices = dbIndices.filter(function (index) {
                    return index["table_schema"] === constraint["table_schema"] && index["table_name"] === constraint["table_name"] && index["constraint_name"] === constraint["constraint_name"];
                  });
                  return new TableIndex({
                    view: view,
                    name: constraint["constraint_name"],
                    columnNames: indices.map(function (i) {
                      return i["column_name"];
                    }),
                    isUnique: constraint["is_unique"] === "TRUE",
                    where: constraint["condition"],
                    isFulltext: false
                  });
                });
                return view;
              }));
            case 23:
            case "end":
              return _context59.stop();
          }
        }, _callee59, this);
      }));
      function loadViews(_x101) {
        return _loadViews.apply(this, arguments);
      }
      return loadViews;
    }()
    /**
     * Loads all tables (with given names) from the database and creates a Table from them.
     */
  }, {
    key: "loadTables",
    value: function () {
      var _loadTables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee62(tableNames) {
        var _this13 = this;
        var currentSchema, currentDatabase, dbTables, tablesSql, tablesCondition, _tablesSql, columnsCondition, columnsSql, constraintsCondition, constraintsSql, indicesSql, foreignKeysCondition, hasRelispartitionColumn, isPartitionCondition, foreignKeysSql, _yield$Promise$all, _yield$Promise$all2, dbColumns, dbConstraints, dbIndices, dbForeignKeys;
        return _regeneratorRuntime().wrap(function _callee62$(_context62) {
          while (1) switch (_context62.prev = _context62.next) {
            case 0:
              if (!(tableNames && tableNames.length === 0)) {
                _context62.next = 2;
                break;
              }
              return _context62.abrupt("return", []);
            case 2:
              _context62.next = 4;
              return this.getCurrentSchema();
            case 4:
              currentSchema = _context62.sent;
              _context62.next = 7;
              return this.getCurrentDatabase();
            case 7:
              currentDatabase = _context62.sent;
              dbTables = [];
              if (tableNames) {
                _context62.next = 21;
                break;
              }
              tablesSql = "SELECT \"table_schema\", \"table_name\" FROM \"information_schema\".\"tables\"";
              _context62.t0 = dbTables.push;
              _context62.t1 = dbTables;
              _context62.t2 = _toConsumableArray;
              _context62.next = 16;
              return this.query(tablesSql);
            case 16:
              _context62.t3 = _context62.sent;
              _context62.t4 = (0, _context62.t2)(_context62.t3);
              _context62.t0.apply.call(_context62.t0, _context62.t1, _context62.t4);
              _context62.next = 31;
              break;
            case 21:
              tablesCondition = tableNames.map(function (tableName) {
                return _this13.driver.parseTableName(tableName);
              }).map(function (_ref7) {
                var schema = _ref7.schema,
                  tableName = _ref7.tableName;
                return "(\"table_schema\" = '".concat(schema || currentSchema, "' AND \"table_name\" = '").concat(tableName, "')");
              }).join(" OR ");
              _tablesSql = "SELECT \"table_schema\", \"table_name\" FROM \"information_schema\".\"tables\" WHERE " + tablesCondition;
              _context62.t5 = dbTables.push;
              _context62.t6 = dbTables;
              _context62.t7 = _toConsumableArray;
              _context62.next = 28;
              return this.query(_tablesSql);
            case 28:
              _context62.t8 = _context62.sent;
              _context62.t9 = (0, _context62.t7)(_context62.t8);
              _context62.t5.apply.call(_context62.t5, _context62.t6, _context62.t9);
            case 31:
              if (!(dbTables.length === 0)) {
                _context62.next = 33;
                break;
              }
              return _context62.abrupt("return", []);
            case 33:
              /**
               * Uses standard SQL information_schema.columns table and postgres-specific
               * pg_catalog.pg_attribute table to get column information.
               * @see https://stackoverflow.com/a/19541865
               */
              columnsCondition = dbTables.map(function (_ref8) {
                var table_schema = _ref8.table_schema,
                  table_name = _ref8.table_name;
                return "(\"table_schema\" = '".concat(table_schema, "' AND \"table_name\" = '").concat(table_name, "')");
              }).join(" OR ");
              columnsSql = "SELECT columns.*, pg_catalog.col_description(('\"' || table_catalog || '\".\"' || table_schema || '\".\"' || table_name || '\"')::regclass::oid, ordinal_position) AS description, " + "('\"' || \"udt_schema\" || '\".\"' || \"udt_name\" || '\"')::\"regtype\" AS \"regtype\", pg_catalog.format_type(\"col_attr\".\"atttypid\", \"col_attr\".\"atttypmod\") AS \"format_type\" " + "FROM \"information_schema\".\"columns\" " + "LEFT JOIN \"pg_catalog\".\"pg_attribute\" AS \"col_attr\" ON \"col_attr\".\"attname\" = \"columns\".\"column_name\" " + "AND \"col_attr\".\"attrelid\" = ( " + "SELECT \"cls\".\"oid\" FROM \"pg_catalog\".\"pg_class\" AS \"cls\" " + "LEFT JOIN \"pg_catalog\".\"pg_namespace\" AS \"ns\" ON \"ns\".\"oid\" = \"cls\".\"relnamespace\" " + "WHERE \"cls\".\"relname\" = \"columns\".\"table_name\" " + "AND \"ns\".\"nspname\" = \"columns\".\"table_schema\" " + ") " + "WHERE " + columnsCondition;
              constraintsCondition = dbTables.map(function (_ref9) {
                var table_schema = _ref9.table_schema,
                  table_name = _ref9.table_name;
                return "(\"ns\".\"nspname\" = '".concat(table_schema, "' AND \"t\".\"relname\" = '").concat(table_name, "')");
              }).join(" OR ");
              constraintsSql = "SELECT \"ns\".\"nspname\" AS \"table_schema\", \"t\".\"relname\" AS \"table_name\", \"cnst\".\"conname\" AS \"constraint_name\", " + "pg_get_constraintdef(\"cnst\".\"oid\") AS \"expression\", " + "CASE \"cnst\".\"contype\" WHEN 'p' THEN 'PRIMARY' WHEN 'u' THEN 'UNIQUE' WHEN 'c' THEN 'CHECK' WHEN 'x' THEN 'EXCLUDE' END AS \"constraint_type\", \"a\".\"attname\" AS \"column_name\" " + "FROM \"pg_constraint\" \"cnst\" " + "INNER JOIN \"pg_class\" \"t\" ON \"t\".\"oid\" = \"cnst\".\"conrelid\" " + "INNER JOIN \"pg_namespace\" \"ns\" ON \"ns\".\"oid\" = \"cnst\".\"connamespace\" " + "LEFT JOIN \"pg_attribute\" \"a\" ON \"a\".\"attrelid\" = \"cnst\".\"conrelid\" AND \"a\".\"attnum\" = ANY (\"cnst\".\"conkey\") " + "WHERE \"t\".\"relkind\" IN ('r', 'p') AND (".concat(constraintsCondition, ")");
              indicesSql = "SELECT \"ns\".\"nspname\" AS \"table_schema\", \"t\".\"relname\" AS \"table_name\", \"i\".\"relname\" AS \"constraint_name\", \"a\".\"attname\" AS \"column_name\", " + "CASE \"ix\".\"indisunique\" WHEN 't' THEN 'TRUE' ELSE'FALSE' END AS \"is_unique\", pg_get_expr(\"ix\".\"indpred\", \"ix\".\"indrelid\") AS \"condition\", " + "\"types\".\"typname\" AS \"type_name\" " + "FROM \"pg_class\" \"t\" " + "INNER JOIN \"pg_index\" \"ix\" ON \"ix\".\"indrelid\" = \"t\".\"oid\" " + "INNER JOIN \"pg_attribute\" \"a\" ON \"a\".\"attrelid\" = \"t\".\"oid\"  AND \"a\".\"attnum\" = ANY (\"ix\".\"indkey\") " + "INNER JOIN \"pg_namespace\" \"ns\" ON \"ns\".\"oid\" = \"t\".\"relnamespace\" " + "INNER JOIN \"pg_class\" \"i\" ON \"i\".\"oid\" = \"ix\".\"indexrelid\" " + "INNER JOIN \"pg_type\" \"types\" ON \"types\".\"oid\" = \"a\".\"atttypid\" " + "LEFT JOIN \"pg_constraint\" \"cnst\" ON \"cnst\".\"conname\" = \"i\".\"relname\" " + "WHERE \"t\".\"relkind\" IN ('r', 'p') AND \"cnst\".\"contype\" IS NULL AND (".concat(constraintsCondition, ")");
              foreignKeysCondition = dbTables.map(function (_ref10) {
                var table_schema = _ref10.table_schema,
                  table_name = _ref10.table_name;
                return "(\"ns\".\"nspname\" = '".concat(table_schema, "' AND \"cl\".\"relname\" = '").concat(table_name, "')");
              }).join(" OR ");
              _context62.next = 41;
              return this.hasSupportForPartitionedTables();
            case 41:
              hasRelispartitionColumn = _context62.sent;
              isPartitionCondition = hasRelispartitionColumn ? " AND \"cl\".\"relispartition\" = 'f'" : "";
              foreignKeysSql = "SELECT \"con\".\"conname\" AS \"constraint_name\", \"con\".\"nspname\" AS \"table_schema\", \"con\".\"relname\" AS \"table_name\", \"att2\".\"attname\" AS \"column_name\", " + "\"ns\".\"nspname\" AS \"referenced_table_schema\", \"cl\".\"relname\" AS \"referenced_table_name\", \"att\".\"attname\" AS \"referenced_column_name\", \"con\".\"confdeltype\" AS \"on_delete\", " + "\"con\".\"confupdtype\" AS \"on_update\", \"con\".\"condeferrable\" AS \"deferrable\", \"con\".\"condeferred\" AS \"deferred\" " + "FROM ( " + "SELECT UNNEST (\"con1\".\"conkey\") AS \"parent\", UNNEST (\"con1\".\"confkey\") AS \"child\", \"con1\".\"confrelid\", \"con1\".\"conrelid\", \"con1\".\"conname\", \"con1\".\"contype\", \"ns\".\"nspname\", " + "\"cl\".\"relname\", \"con1\".\"condeferrable\", " + "CASE WHEN \"con1\".\"condeferred\" THEN 'INITIALLY DEFERRED' ELSE 'INITIALLY IMMEDIATE' END as condeferred, " + "CASE \"con1\".\"confdeltype\" WHEN 'a' THEN 'NO ACTION' WHEN 'r' THEN 'RESTRICT' WHEN 'c' THEN 'CASCADE' WHEN 'n' THEN 'SET NULL' WHEN 'd' THEN 'SET DEFAULT' END as \"confdeltype\", " + "CASE \"con1\".\"confupdtype\" WHEN 'a' THEN 'NO ACTION' WHEN 'r' THEN 'RESTRICT' WHEN 'c' THEN 'CASCADE' WHEN 'n' THEN 'SET NULL' WHEN 'd' THEN 'SET DEFAULT' END as \"confupdtype\" " + "FROM \"pg_class\" \"cl\" " + "INNER JOIN \"pg_namespace\" \"ns\" ON \"cl\".\"relnamespace\" = \"ns\".\"oid\" " + "INNER JOIN \"pg_constraint\" \"con1\" ON \"con1\".\"conrelid\" = \"cl\".\"oid\" " + "WHERE \"con1\".\"contype\" = 'f' AND (".concat(foreignKeysCondition, ") ") + ") \"con\" " + "INNER JOIN \"pg_attribute\" \"att\" ON \"att\".\"attrelid\" = \"con\".\"confrelid\" AND \"att\".\"attnum\" = \"con\".\"child\" " + "INNER JOIN \"pg_class\" \"cl\" ON \"cl\".\"oid\" = \"con\".\"confrelid\" ".concat(isPartitionCondition) + "INNER JOIN \"pg_namespace\" \"ns\" ON \"cl\".\"relnamespace\" = \"ns\".\"oid\" " + "INNER JOIN \"pg_attribute\" \"att2\" ON \"att2\".\"attrelid\" = \"con\".\"conrelid\" AND \"att2\".\"attnum\" = \"con\".\"parent\"";
              _context62.next = 46;
              return Promise.all([this.query(columnsSql), this.query(constraintsSql), this.query(indicesSql), this.query(foreignKeysSql)]);
            case 46:
              _yield$Promise$all = _context62.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 4);
              dbColumns = _yield$Promise$all2[0];
              dbConstraints = _yield$Promise$all2[1];
              dbIndices = _yield$Promise$all2[2];
              dbForeignKeys = _yield$Promise$all2[3];
              return _context62.abrupt("return", Promise.all(dbTables.map( /*#__PURE__*/function () {
                var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee61(dbTable) {
                  var table, getSchemaFromKey, schema, tableUniqueConstraints, tableCheckConstraints, tableExclusionConstraints, tableForeignKeyConstraints, tableIndexConstraints;
                  return _regeneratorRuntime().wrap(function _callee61$(_context61) {
                    while (1) switch (_context61.prev = _context61.next) {
                      case 0:
                        table = new Table();
                        getSchemaFromKey = function getSchemaFromKey(dbObject, key) {
                          return dbObject[key] === currentSchema && (!_this13.driver.options.schema || _this13.driver.options.schema === currentSchema) ? undefined : dbObject[key];
                        }; // We do not need to join schema name, when database is by default.
                        schema = getSchemaFromKey(dbTable, "table_schema");
                        table.database = currentDatabase;
                        table.schema = dbTable["table_schema"];
                        table.name = _this13.driver.buildTableName(dbTable["table_name"], schema);
                        // create columns from the loaded columns
                        _context61.next = 8;
                        return Promise.all(dbColumns.filter(function (dbColumn) {
                          return dbColumn["table_name"] === dbTable["table_name"] && dbColumn["table_schema"] === dbTable["table_schema"];
                        }).map( /*#__PURE__*/function () {
                          var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee60(dbColumn) {
                            var columnConstraints, tableColumn, _yield$_this13$getUse, name, builtEnumName, enumName, sql, results, type, geometryColumnSql, _results, geographyColumnSql, _results2, length, match, primaryConstraint, anotherPrimaryConstraints, columnNames, pkName, uniqueConstraints, isConstraintComposite, serialDefaultName, serialDefaultPath, defaultWithoutQuotes, asExpressionQuery, _results3;
                            return _regeneratorRuntime().wrap(function _callee60$(_context60) {
                              while (1) switch (_context60.prev = _context60.next) {
                                case 0:
                                  columnConstraints = dbConstraints.filter(function (dbConstraint) {
                                    return dbConstraint["table_name"] === dbColumn["table_name"] && dbConstraint["table_schema"] === dbColumn["table_schema"] && dbConstraint["column_name"] === dbColumn["column_name"];
                                  });
                                  tableColumn = new TableColumn();
                                  tableColumn.name = dbColumn["column_name"];
                                  tableColumn.type = dbColumn["regtype"].toLowerCase();
                                  if (tableColumn.type === "numeric" || tableColumn.type === "decimal" || tableColumn.type === "float") {
                                    // If one of these properties was set, and another was not, Postgres sets '0' in to unspecified property
                                    // we set 'undefined' in to unspecified property to avoid changing column on sync
                                    if (dbColumn["numeric_precision"] !== null && !_this13.isDefaultColumnPrecision(table, tableColumn, dbColumn["numeric_precision"])) {
                                      tableColumn.precision = dbColumn["numeric_precision"];
                                    } else if (dbColumn["numeric_scale"] !== null && !_this13.isDefaultColumnScale(table, tableColumn, dbColumn["numeric_scale"])) {
                                      tableColumn.precision = undefined;
                                    }
                                    if (dbColumn["numeric_scale"] !== null && !_this13.isDefaultColumnScale(table, tableColumn, dbColumn["numeric_scale"])) {
                                      tableColumn.scale = dbColumn["numeric_scale"];
                                    } else if (dbColumn["numeric_precision"] !== null && !_this13.isDefaultColumnPrecision(table, tableColumn, dbColumn["numeric_precision"])) {
                                      tableColumn.scale = undefined;
                                    }
                                  }
                                  if (tableColumn.type === "interval" || tableColumn.type === "time without time zone" || tableColumn.type === "time with time zone" || tableColumn.type === "timestamp without time zone" || tableColumn.type === "timestamp with time zone") {
                                    tableColumn.precision = !_this13.isDefaultColumnPrecision(table, tableColumn, dbColumn["datetime_precision"]) ? dbColumn["datetime_precision"] : undefined;
                                  }
                                  // check if column has user-defined data type.
                                  // NOTE: if ENUM type defined with "array:true" it comes with ARRAY type instead of USER-DEFINED
                                  if (!(dbColumn["data_type"] === "USER-DEFINED" || dbColumn["data_type"] === "ARRAY")) {
                                    _context60.next = 19;
                                    break;
                                  }
                                  _context60.next = 9;
                                  return _this13.getUserDefinedTypeName(table, tableColumn);
                                case 9:
                                  _yield$_this13$getUse = _context60.sent;
                                  name = _yield$_this13$getUse.name;
                                  // check if `enumName` is specified by user
                                  builtEnumName = _this13.buildEnumName(table, tableColumn, false, true);
                                  enumName = builtEnumName !== name ? name : undefined; // check if type is ENUM
                                  sql = "SELECT \"e\".\"enumlabel\" AS \"value\" FROM \"pg_enum\" \"e\" " + "INNER JOIN \"pg_type\" \"t\" ON \"t\".\"oid\" = \"e\".\"enumtypid\" " + "INNER JOIN \"pg_namespace\" \"n\" ON \"n\".\"oid\" = \"t\".\"typnamespace\" " + "WHERE \"n\".\"nspname\" = '".concat(dbTable["table_schema"], "' AND \"t\".\"typname\" = '").concat(enumName || name, "'");
                                  _context60.next = 16;
                                  return _this13.query(sql);
                                case 16:
                                  results = _context60.sent;
                                  if (results.length) {
                                    tableColumn.type = "enum";
                                    tableColumn.enum = results.map(function (result) {
                                      return result["value"];
                                    });
                                    tableColumn.enumName = enumName;
                                  }
                                  if (dbColumn["data_type"] === "ARRAY") {
                                    tableColumn.isArray = true;
                                    type = tableColumn.type.replace("[]", "");
                                    tableColumn.type = _this13.connection.driver.normalizeType({
                                      type: type
                                    });
                                  }
                                case 19:
                                  if (!(tableColumn.type === "geometry")) {
                                    _context60.next = 25;
                                    break;
                                  }
                                  geometryColumnSql = "SELECT * FROM (\n                        SELECT\n                          \"f_table_schema\" \"table_schema\",\n                          \"f_table_name\" \"table_name\",\n                          \"f_geometry_column\" \"column_name\",\n                          \"srid\",\n                          \"type\"\n                        FROM \"geometry_columns\"\n                      ) AS _\n                      WHERE\n                          \"column_name\" = '".concat(dbColumn["column_name"], "' AND\n                          \"table_schema\" = '").concat(dbColumn["table_schema"], "' AND\n                          \"table_name\" = '").concat(dbColumn["table_name"], "'");
                                  _context60.next = 23;
                                  return _this13.query(geometryColumnSql);
                                case 23:
                                  _results = _context60.sent;
                                  if (_results.length > 0) {
                                    tableColumn.spatialFeatureType = _results[0].type;
                                    tableColumn.srid = _results[0].srid;
                                  }
                                case 25:
                                  if (!(tableColumn.type === "geography")) {
                                    _context60.next = 31;
                                    break;
                                  }
                                  geographyColumnSql = "SELECT * FROM (\n                        SELECT\n                          \"f_table_schema\" \"table_schema\",\n                          \"f_table_name\" \"table_name\",\n                          \"f_geography_column\" \"column_name\",\n                          \"srid\",\n                          \"type\"\n                        FROM \"geography_columns\"\n                      ) AS _\n                      WHERE\n                          \"column_name\" = '".concat(dbColumn["column_name"], "' AND\n                          \"table_schema\" = '").concat(dbColumn["table_schema"], "' AND\n                          \"table_name\" = '").concat(dbColumn["table_name"], "'");
                                  _context60.next = 29;
                                  return _this13.query(geographyColumnSql);
                                case 29:
                                  _results2 = _context60.sent;
                                  if (_results2.length > 0) {
                                    tableColumn.spatialFeatureType = _results2[0].type;
                                    tableColumn.srid = _results2[0].srid;
                                  }
                                case 31:
                                  // check only columns that have length property
                                  if (_this13.driver.withLengthColumnTypes.indexOf(tableColumn.type) !== -1) {
                                    if (tableColumn.isArray) {
                                      match = /\((\d+)\)/.exec(dbColumn["format_type"]);
                                      length = match ? match[1] : undefined;
                                    } else if (dbColumn["character_maximum_length"]) {
                                      length = dbColumn["character_maximum_length"].toString();
                                    }
                                    if (length) {
                                      tableColumn.length = !_this13.isDefaultColumnLength(table, tableColumn, length) ? length : "";
                                    }
                                  }
                                  tableColumn.isNullable = dbColumn["is_nullable"] === "YES";
                                  primaryConstraint = columnConstraints.find(function (constraint) {
                                    return constraint["constraint_type"] === "PRIMARY";
                                  });
                                  if (primaryConstraint) {
                                    tableColumn.isPrimary = true;
                                    // find another columns involved in primary key constraint
                                    anotherPrimaryConstraints = dbConstraints.filter(function (constraint) {
                                      return constraint["table_name"] === dbColumn["table_name"] && constraint["table_schema"] === dbColumn["table_schema"] && constraint["column_name"] !== dbColumn["column_name"] && constraint["constraint_type"] === "PRIMARY";
                                    }); // collect all column names
                                    columnNames = anotherPrimaryConstraints.map(function (constraint) {
                                      return constraint["column_name"];
                                    });
                                    columnNames.push(dbColumn["column_name"]);
                                    // build default primary key constraint name
                                    pkName = _this13.connection.namingStrategy.primaryKeyName(table, columnNames); // if primary key has user-defined constraint name, write it in table column
                                    if (primaryConstraint["constraint_name"] !== pkName) {
                                      tableColumn.primaryKeyConstraintName = primaryConstraint["constraint_name"];
                                    }
                                  }
                                  uniqueConstraints = columnConstraints.filter(function (constraint) {
                                    return constraint["constraint_type"] === "UNIQUE";
                                  });
                                  isConstraintComposite = uniqueConstraints.every(function (uniqueConstraint) {
                                    return dbConstraints.some(function (dbConstraint) {
                                      return dbConstraint["constraint_type"] === "UNIQUE" && dbConstraint["constraint_name"] === uniqueConstraint["constraint_name"] && dbConstraint["column_name"] !== dbColumn["column_name"];
                                    });
                                  });
                                  tableColumn.isUnique = uniqueConstraints.length > 0 && !isConstraintComposite;
                                  if (dbColumn.is_identity === "YES") {
                                    // Postgres 10+ Identity column
                                    tableColumn.isGenerated = true;
                                    tableColumn.generationStrategy = "identity";
                                    tableColumn.generatedIdentity = dbColumn.identity_generation;
                                  } else if (dbColumn["column_default"] !== null && dbColumn["column_default"] !== undefined) {
                                    serialDefaultName = "nextval('".concat(_this13.buildSequenceName(table, dbColumn["column_name"]), "'::regclass)");
                                    serialDefaultPath = "nextval('".concat(_this13.buildSequencePath(table, dbColumn["column_name"]), "'::regclass)");
                                    defaultWithoutQuotes = dbColumn["column_default"].replace(/"/g, "");
                                    if (defaultWithoutQuotes === serialDefaultName || defaultWithoutQuotes === serialDefaultPath) {
                                      tableColumn.isGenerated = true;
                                      tableColumn.generationStrategy = "increment";
                                    } else if (dbColumn["column_default"] === "gen_random_uuid()" || /^uuid_generate_v\d\(\)/.test(dbColumn["column_default"])) {
                                      if (tableColumn.type === "uuid") {
                                        tableColumn.isGenerated = true;
                                        tableColumn.generationStrategy = "uuid";
                                      } else {
                                        tableColumn.default = dbColumn["column_default"];
                                      }
                                    } else if (dbColumn["column_default"] === "now()" || dbColumn["column_default"].indexOf("'now'::text") !== -1) {
                                      tableColumn.default = dbColumn["column_default"];
                                    } else {
                                      tableColumn.default = dbColumn["column_default"].replace(/::[\w\s\.\[\]\"]+/g, "");
                                      tableColumn.default = tableColumn.default.replace(/^(-?\d+)$/, "'$1'");
                                    }
                                  }
                                  if (!(dbColumn["is_generated"] === "ALWAYS" && dbColumn["generation_expression"])) {
                                    _context60.next = 48;
                                    break;
                                  }
                                  // In postgres there is no VIRTUAL generated column type
                                  tableColumn.generatedType = "STORED";
                                  // We cannot relay on information_schema.columns.generation_expression, because it is formatted different.
                                  _context60.next = 43;
                                  return _this13.selectTypeormMetadataSql({
                                    database: currentDatabase,
                                    schema: dbTable["table_schema"],
                                    table: dbTable["table_name"],
                                    type: MetadataTableType.GENERATED_COLUMN,
                                    name: tableColumn.name
                                  });
                                case 43:
                                  asExpressionQuery = _context60.sent;
                                  _context60.next = 46;
                                  return _this13.query(asExpressionQuery.query, asExpressionQuery.parameters);
                                case 46:
                                  _results3 = _context60.sent;
                                  if (_results3[0] && _results3[0].value) {
                                    tableColumn.asExpression = _results3[0].value;
                                  } else {
                                    tableColumn.asExpression = "";
                                  }
                                case 48:
                                  tableColumn.comment = dbColumn["description"] ? dbColumn["description"] : undefined;
                                  if (dbColumn["character_set_name"]) tableColumn.charset = dbColumn["character_set_name"];
                                  if (dbColumn["collation_name"]) tableColumn.collation = dbColumn["collation_name"];
                                  return _context60.abrupt("return", tableColumn);
                                case 52:
                                case "end":
                                  return _context60.stop();
                              }
                            }, _callee60);
                          }));
                          return function (_x104) {
                            return _ref12.apply(this, arguments);
                          };
                        }()));
                      case 8:
                        table.columns = _context61.sent;
                        // find unique constraints of table, group them by constraint name and build TableUnique.
                        tableUniqueConstraints = OrmUtils.uniq(dbConstraints.filter(function (dbConstraint) {
                          return dbConstraint["table_name"] === dbTable["table_name"] && dbConstraint["table_schema"] === dbTable["table_schema"] && dbConstraint["constraint_type"] === "UNIQUE";
                        }), function (dbConstraint) {
                          return dbConstraint["constraint_name"];
                        });
                        table.uniques = tableUniqueConstraints.map(function (constraint) {
                          var uniques = dbConstraints.filter(function (dbC) {
                            return dbC["constraint_name"] === constraint["constraint_name"];
                          });
                          return new TableUnique({
                            name: constraint["constraint_name"],
                            columnNames: uniques.map(function (u) {
                              return u["column_name"];
                            }),
                            deferrable: constraint["deferrable"] ? constraint["deferred"] : undefined
                          });
                        });
                        // find check constraints of table, group them by constraint name and build TableCheck.
                        tableCheckConstraints = OrmUtils.uniq(dbConstraints.filter(function (dbConstraint) {
                          return dbConstraint["table_name"] === dbTable["table_name"] && dbConstraint["table_schema"] === dbTable["table_schema"] && dbConstraint["constraint_type"] === "CHECK";
                        }), function (dbConstraint) {
                          return dbConstraint["constraint_name"];
                        });
                        table.checks = tableCheckConstraints.map(function (constraint) {
                          var checks = dbConstraints.filter(function (dbC) {
                            return dbC["constraint_name"] === constraint["constraint_name"];
                          });
                          return new TableCheck({
                            name: constraint["constraint_name"],
                            columnNames: checks.map(function (c) {
                              return c["column_name"];
                            }),
                            expression: constraint["expression"].replace(/^\s*CHECK\s*\((.*)\)\s*$/i, "$1")
                          });
                        });
                        // find exclusion constraints of table, group them by constraint name and build TableExclusion.
                        tableExclusionConstraints = OrmUtils.uniq(dbConstraints.filter(function (dbConstraint) {
                          return dbConstraint["table_name"] === dbTable["table_name"] && dbConstraint["table_schema"] === dbTable["table_schema"] && dbConstraint["constraint_type"] === "EXCLUDE";
                        }), function (dbConstraint) {
                          return dbConstraint["constraint_name"];
                        });
                        table.exclusions = tableExclusionConstraints.map(function (constraint) {
                          return new TableExclusion({
                            name: constraint["constraint_name"],
                            expression: constraint["expression"].substring(8) // trim EXCLUDE from start of expression
                          });
                        });
                        // find foreign key constraints of table, group them by constraint name and build TableForeignKey.
                        tableForeignKeyConstraints = OrmUtils.uniq(dbForeignKeys.filter(function (dbForeignKey) {
                          return dbForeignKey["table_name"] === dbTable["table_name"] && dbForeignKey["table_schema"] === dbTable["table_schema"];
                        }), function (dbForeignKey) {
                          return dbForeignKey["constraint_name"];
                        });
                        table.foreignKeys = tableForeignKeyConstraints.map(function (dbForeignKey) {
                          var foreignKeys = dbForeignKeys.filter(function (dbFk) {
                            return dbFk["constraint_name"] === dbForeignKey["constraint_name"];
                          });
                          // if referenced table located in currently used schema, we don't need to concat schema name to table name.
                          var schema = getSchemaFromKey(dbForeignKey, "referenced_table_schema");
                          var referencedTableName = _this13.driver.buildTableName(dbForeignKey["referenced_table_name"], schema);
                          return new TableForeignKey({
                            name: dbForeignKey["constraint_name"],
                            columnNames: foreignKeys.map(function (dbFk) {
                              return dbFk["column_name"];
                            }),
                            referencedSchema: dbForeignKey["referenced_table_schema"],
                            referencedTableName: referencedTableName,
                            referencedColumnNames: foreignKeys.map(function (dbFk) {
                              return dbFk["referenced_column_name"];
                            }),
                            onDelete: dbForeignKey["on_delete"],
                            onUpdate: dbForeignKey["on_update"],
                            deferrable: dbForeignKey["deferrable"] ? dbForeignKey["deferred"] : undefined
                          });
                        });
                        // find index constraints of table, group them by constraint name and build TableIndex.
                        tableIndexConstraints = OrmUtils.uniq(dbIndices.filter(function (dbIndex) {
                          return dbIndex["table_name"] === dbTable["table_name"] && dbIndex["table_schema"] === dbTable["table_schema"];
                        }), function (dbIndex) {
                          return dbIndex["constraint_name"];
                        });
                        table.indices = tableIndexConstraints.map(function (constraint) {
                          var indices = dbIndices.filter(function (index) {
                            return index["table_schema"] === constraint["table_schema"] && index["table_name"] === constraint["table_name"] && index["constraint_name"] === constraint["constraint_name"];
                          });
                          return new TableIndex({
                            table: table,
                            name: constraint["constraint_name"],
                            columnNames: indices.map(function (i) {
                              return i["column_name"];
                            }),
                            isUnique: constraint["is_unique"] === "TRUE",
                            where: constraint["condition"],
                            isSpatial: indices.every(function (i) {
                              return _this13.driver.spatialTypes.indexOf(i["type_name"]) >= 0;
                            }),
                            isFulltext: false
                          });
                        });
                        return _context61.abrupt("return", table);
                      case 20:
                      case "end":
                        return _context61.stop();
                    }
                  }, _callee61);
                }));
                return function (_x103) {
                  return _ref11.apply(this, arguments);
                };
              }())));
            case 53:
            case "end":
              return _context62.stop();
          }
        }, _callee62, this);
      }));
      function loadTables(_x102) {
        return _loadTables.apply(this, arguments);
      }
      return loadTables;
    }()
    /**
     * Builds create table sql.
     */
  }, {
    key: "createTableSql",
    value: function createTableSql(table, createForeignKeys) {
      var _this14 = this;
      var columnDefinitions = table.columns.map(function (column) {
        return _this14.buildCreateColumnSql(table, column);
      }).join(", ");
      var sql = "CREATE TABLE ".concat(this.escapePath(table), " (").concat(columnDefinitions);
      table.columns.filter(function (column) {
        return column.isUnique;
      }).forEach(function (column) {
        var isUniqueExist = table.uniques.some(function (unique) {
          return unique.columnNames.length === 1 && unique.columnNames[0] === column.name;
        });
        if (!isUniqueExist) table.uniques.push(new TableUnique({
          name: _this14.connection.namingStrategy.uniqueConstraintName(table, [column.name]),
          columnNames: [column.name]
        }));
      });
      if (table.uniques.length > 0) {
        var uniquesSql = table.uniques.map(function (unique) {
          var uniqueName = unique.name ? unique.name : _this14.connection.namingStrategy.uniqueConstraintName(table, unique.columnNames);
          var columnNames = unique.columnNames.map(function (columnName) {
            return "\"".concat(columnName, "\"");
          }).join(", ");
          var constraint = "CONSTRAINT \"".concat(uniqueName, "\" UNIQUE (").concat(columnNames, ")");
          if (unique.deferrable) constraint += " DEFERRABLE ".concat(unique.deferrable);
          return constraint;
        }).join(", ");
        sql += ", ".concat(uniquesSql);
      }
      if (table.checks.length > 0) {
        var checksSql = table.checks.map(function (check) {
          var checkName = check.name ? check.name : _this14.connection.namingStrategy.checkConstraintName(table, check.expression);
          return "CONSTRAINT \"".concat(checkName, "\" CHECK (").concat(check.expression, ")");
        }).join(", ");
        sql += ", ".concat(checksSql);
      }
      if (table.exclusions.length > 0) {
        var exclusionsSql = table.exclusions.map(function (exclusion) {
          var exclusionName = exclusion.name ? exclusion.name : _this14.connection.namingStrategy.exclusionConstraintName(table, exclusion.expression);
          return "CONSTRAINT \"".concat(exclusionName, "\" EXCLUDE ").concat(exclusion.expression);
        }).join(", ");
        sql += ", ".concat(exclusionsSql);
      }
      if (table.foreignKeys.length > 0 && createForeignKeys) {
        var foreignKeysSql = table.foreignKeys.map(function (fk) {
          var columnNames = fk.columnNames.map(function (columnName) {
            return "\"".concat(columnName, "\"");
          }).join(", ");
          if (!fk.name) fk.name = _this14.connection.namingStrategy.foreignKeyName(table, fk.columnNames, _this14.getTablePath(fk), fk.referencedColumnNames);
          var referencedColumnNames = fk.referencedColumnNames.map(function (columnName) {
            return "\"".concat(columnName, "\"");
          }).join(", ");
          var constraint = "CONSTRAINT \"".concat(fk.name, "\" FOREIGN KEY (").concat(columnNames, ") REFERENCES ").concat(_this14.escapePath(_this14.getTablePath(fk)), " (").concat(referencedColumnNames, ")");
          if (fk.onDelete) constraint += " ON DELETE ".concat(fk.onDelete);
          if (fk.onUpdate) constraint += " ON UPDATE ".concat(fk.onUpdate);
          if (fk.deferrable) constraint += " DEFERRABLE ".concat(fk.deferrable);
          return constraint;
        }).join(", ");
        sql += ", ".concat(foreignKeysSql);
      }
      var primaryColumns = table.columns.filter(function (column) {
        return column.isPrimary;
      });
      if (primaryColumns.length > 0) {
        var primaryKeyName = primaryColumns[0].primaryKeyConstraintName ? primaryColumns[0].primaryKeyConstraintName : this.connection.namingStrategy.primaryKeyName(table, primaryColumns.map(function (column) {
          return column.name;
        }));
        var columnNames = primaryColumns.map(function (column) {
          return "\"".concat(column.name, "\"");
        }).join(", ");
        sql += ", CONSTRAINT \"".concat(primaryKeyName, "\" PRIMARY KEY (").concat(columnNames, ")");
      }
      sql += ")";
      table.columns.filter(function (it) {
        return it.comment;
      }).forEach(function (it) {
        return sql += "; COMMENT ON COLUMN ".concat(_this14.escapePath(table), ".\"").concat(it.name, "\" IS ").concat(_this14.escapeComment(it.comment));
      });
      return new Query(sql);
    }
    /**
     * Loads Postgres version.
     */
  }, {
    key: "getVersion",
    value: function () {
      var _getVersion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee63() {
        var result;
        return _regeneratorRuntime().wrap(function _callee63$(_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              _context63.next = 2;
              return this.query("SELECT version()");
            case 2:
              result = _context63.sent;
              return _context63.abrupt("return", result[0]["version"].replace(/^PostgreSQL ([\d\.]+) .*$/, "$1"));
            case 4:
            case "end":
              return _context63.stop();
          }
        }, _callee63, this);
      }));
      function getVersion() {
        return _getVersion.apply(this, arguments);
      }
      return getVersion;
    }()
    /**
     * Builds drop table sql.
     */
  }, {
    key: "dropTableSql",
    value: function dropTableSql(tableOrPath) {
      return new Query("DROP TABLE ".concat(this.escapePath(tableOrPath)));
    }
  }, {
    key: "createViewSql",
    value: function createViewSql(view) {
      var materializedClause = view.materialized ? "MATERIALIZED " : "";
      var viewName = this.escapePath(view);
      if (typeof view.expression === "string") {
        return new Query("CREATE ".concat(materializedClause, "VIEW ").concat(viewName, " AS ").concat(view.expression));
      } else {
        return new Query("CREATE ".concat(materializedClause, "VIEW ").concat(viewName, " AS ").concat(view.expression(this.connection).getQuery()));
      }
    }
  }, {
    key: "insertViewDefinitionSql",
    value: function () {
      var _insertViewDefinitionSql = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee64(view) {
        var currentSchema, _this$driver$parseTab2, schema, name, type, expression;
        return _regeneratorRuntime().wrap(function _callee64$(_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              _context64.next = 2;
              return this.getCurrentSchema();
            case 2:
              currentSchema = _context64.sent;
              _this$driver$parseTab2 = this.driver.parseTableName(view), schema = _this$driver$parseTab2.schema, name = _this$driver$parseTab2.tableName;
              if (!schema) {
                schema = currentSchema;
              }
              type = view.materialized ? MetadataTableType.MATERIALIZED_VIEW : MetadataTableType.VIEW;
              expression = typeof view.expression === "string" ? view.expression.trim() : view.expression(this.connection).getQuery();
              return _context64.abrupt("return", this.insertTypeormMetadataSql({
                type: type,
                schema: schema,
                name: name,
                value: expression
              }));
            case 8:
            case "end":
              return _context64.stop();
          }
        }, _callee64, this);
      }));
      function insertViewDefinitionSql(_x105) {
        return _insertViewDefinitionSql.apply(this, arguments);
      }
      return insertViewDefinitionSql;
    }()
    /**
     * Builds drop view sql.
     */
  }, {
    key: "dropViewSql",
    value: function dropViewSql(view) {
      var materializedClause = view.materialized ? "MATERIALIZED " : "";
      return new Query("DROP ".concat(materializedClause, "VIEW ").concat(this.escapePath(view)));
    }
    /**
     * Builds remove view sql.
     */
  }, {
    key: "deleteViewDefinitionSql",
    value: function () {
      var _deleteViewDefinitionSql = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee65(view) {
        var currentSchema, _this$driver$parseTab3, schema, name, type;
        return _regeneratorRuntime().wrap(function _callee65$(_context65) {
          while (1) switch (_context65.prev = _context65.next) {
            case 0:
              _context65.next = 2;
              return this.getCurrentSchema();
            case 2:
              currentSchema = _context65.sent;
              _this$driver$parseTab3 = this.driver.parseTableName(view), schema = _this$driver$parseTab3.schema, name = _this$driver$parseTab3.tableName;
              if (!schema) {
                schema = currentSchema;
              }
              type = view.materialized ? MetadataTableType.MATERIALIZED_VIEW : MetadataTableType.VIEW;
              return _context65.abrupt("return", this.deleteTypeormMetadataSql({
                type: type,
                schema: schema,
                name: name
              }));
            case 7:
            case "end":
              return _context65.stop();
          }
        }, _callee65, this);
      }));
      function deleteViewDefinitionSql(_x106) {
        return _deleteViewDefinitionSql.apply(this, arguments);
      }
      return deleteViewDefinitionSql;
    }()
    /**
     * Drops ENUM type from given schemas.
     */
  }, {
    key: "dropEnumTypes",
    value: function () {
      var _dropEnumTypes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee66(schemaNames) {
        var _this15 = this;
        var selectDropsQuery, dropQueries;
        return _regeneratorRuntime().wrap(function _callee66$(_context66) {
          while (1) switch (_context66.prev = _context66.next) {
            case 0:
              selectDropsQuery = "SELECT 'DROP TYPE IF EXISTS \"' || n.nspname || '\".\"' || t.typname || '\" CASCADE;' as \"query\" FROM \"pg_type\" \"t\" " + "INNER JOIN \"pg_enum\" \"e\" ON \"e\".\"enumtypid\" = \"t\".\"oid\" " + "INNER JOIN \"pg_namespace\" \"n\" ON \"n\".\"oid\" = \"t\".\"typnamespace\" " + "WHERE \"n\".\"nspname\" IN (".concat(schemaNames, ") GROUP BY \"n\".\"nspname\", \"t\".\"typname\"");
              _context66.next = 3;
              return this.query(selectDropsQuery);
            case 3:
              dropQueries = _context66.sent;
              _context66.next = 6;
              return Promise.all(dropQueries.map(function (q) {
                return _this15.query(q["query"]);
              }));
            case 6:
            case "end":
              return _context66.stop();
          }
        }, _callee66, this);
      }));
      function dropEnumTypes(_x107) {
        return _dropEnumTypes.apply(this, arguments);
      }
      return dropEnumTypes;
    }()
    /**
     * Checks if enum with the given name exist in the database.
     */
  }, {
    key: "hasEnumType",
    value: function () {
      var _hasEnumType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee67(table, column) {
        var _this$driver$parseTab4, schema, enumName, sql, result;
        return _regeneratorRuntime().wrap(function _callee67$(_context67) {
          while (1) switch (_context67.prev = _context67.next) {
            case 0:
              _this$driver$parseTab4 = this.driver.parseTableName(table), schema = _this$driver$parseTab4.schema;
              if (schema) {
                _context67.next = 5;
                break;
              }
              _context67.next = 4;
              return this.getCurrentSchema();
            case 4:
              schema = _context67.sent;
            case 5:
              enumName = this.buildEnumName(table, column, false, true);
              sql = "SELECT \"n\".\"nspname\", \"t\".\"typname\" FROM \"pg_type\" \"t\" " + "INNER JOIN \"pg_namespace\" \"n\" ON \"n\".\"oid\" = \"t\".\"typnamespace\" " + "WHERE \"n\".\"nspname\" = '".concat(schema, "' AND \"t\".\"typname\" = '").concat(enumName, "'");
              _context67.next = 9;
              return this.query(sql);
            case 9:
              result = _context67.sent;
              return _context67.abrupt("return", result.length ? true : false);
            case 11:
            case "end":
              return _context67.stop();
          }
        }, _callee67, this);
      }));
      function hasEnumType(_x108, _x109) {
        return _hasEnumType.apply(this, arguments);
      }
      return hasEnumType;
    }()
    /**
     * Builds create ENUM type sql.
     */
  }, {
    key: "createEnumTypeSql",
    value: function createEnumTypeSql(table, column, enumName) {
      if (!enumName) enumName = this.buildEnumName(table, column);
      var enumValues = column.enum.map(function (value) {
        return "'".concat(value.replace("'", "''"), "'");
      }).join(", ");
      return new Query("CREATE TYPE ".concat(enumName, " AS ENUM(").concat(enumValues, ")"));
    }
    /**
     * Builds create ENUM type sql.
     */
  }, {
    key: "dropEnumTypeSql",
    value: function dropEnumTypeSql(table, column, enumName) {
      if (!enumName) enumName = this.buildEnumName(table, column);
      return new Query("DROP TYPE ".concat(enumName));
    }
    /**
     * Builds create index sql.
     */
  }, {
    key: "createIndexSql",
    value: function createIndexSql(table, index) {
      var columns = index.columnNames.map(function (columnName) {
        return "\"".concat(columnName, "\"");
      }).join(", ");
      return new Query("CREATE ".concat(index.isUnique ? "UNIQUE " : "", "INDEX \"").concat(index.name, "\" ON ").concat(this.escapePath(table), " ").concat(index.isSpatial ? "USING GiST " : "", "(").concat(columns, ") ").concat(index.where ? "WHERE " + index.where : ""));
    }
    /**
     * Builds create view index sql.
     */
  }, {
    key: "createViewIndexSql",
    value: function createViewIndexSql(view, index) {
      var columns = index.columnNames.map(function (columnName) {
        return "\"".concat(columnName, "\"");
      }).join(", ");
      return new Query("CREATE ".concat(index.isUnique ? "UNIQUE " : "", "INDEX \"").concat(index.name, "\" ON ").concat(this.escapePath(view), " (").concat(columns, ") ").concat(index.where ? "WHERE " + index.where : ""));
    }
    /**
     * Builds drop index sql.
     */
  }, {
    key: "dropIndexSql",
    value: function dropIndexSql(table, indexOrName) {
      var indexName = InstanceChecker.isTableIndex(indexOrName) ? indexOrName.name : indexOrName;
      var _this$driver$parseTab5 = this.driver.parseTableName(table),
        schema = _this$driver$parseTab5.schema;
      return schema ? new Query("DROP INDEX \"".concat(schema, "\".\"").concat(indexName, "\"")) : new Query("DROP INDEX \"".concat(indexName, "\""));
    }
    /**
     * Builds create primary key sql.
     */
  }, {
    key: "createPrimaryKeySql",
    value: function createPrimaryKeySql(table, columnNames, constraintName) {
      var primaryKeyName = constraintName ? constraintName : this.connection.namingStrategy.primaryKeyName(table, columnNames);
      var columnNamesString = columnNames.map(function (columnName) {
        return "\"".concat(columnName, "\"");
      }).join(", ");
      return new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT \"").concat(primaryKeyName, "\" PRIMARY KEY (").concat(columnNamesString, ")"));
    }
    /**
     * Builds drop primary key sql.
     */
  }, {
    key: "dropPrimaryKeySql",
    value: function dropPrimaryKeySql(table) {
      if (!table.primaryColumns.length) throw new TypeORMError("Table ".concat(table, " has no primary keys."));
      var columnNames = table.primaryColumns.map(function (column) {
        return column.name;
      });
      var constraintName = table.primaryColumns[0].primaryKeyConstraintName;
      var primaryKeyName = constraintName ? constraintName : this.connection.namingStrategy.primaryKeyName(table, columnNames);
      return new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP CONSTRAINT \"").concat(primaryKeyName, "\""));
    }
    /**
     * Builds create unique constraint sql.
     */
  }, {
    key: "createUniqueConstraintSql",
    value: function createUniqueConstraintSql(table, uniqueConstraint) {
      var columnNames = uniqueConstraint.columnNames.map(function (column) {
        return "\"" + column + "\"";
      }).join(", ");
      var sql = "ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT \"").concat(uniqueConstraint.name, "\" UNIQUE (").concat(columnNames, ")");
      if (uniqueConstraint.deferrable) sql += " DEFERRABLE ".concat(uniqueConstraint.deferrable);
      return new Query(sql);
    }
    /**
     * Builds drop unique constraint sql.
     */
  }, {
    key: "dropUniqueConstraintSql",
    value: function dropUniqueConstraintSql(table, uniqueOrName) {
      var uniqueName = InstanceChecker.isTableUnique(uniqueOrName) ? uniqueOrName.name : uniqueOrName;
      return new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP CONSTRAINT \"").concat(uniqueName, "\""));
    }
    /**
     * Builds create check constraint sql.
     */
  }, {
    key: "createCheckConstraintSql",
    value: function createCheckConstraintSql(table, checkConstraint) {
      return new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT \"").concat(checkConstraint.name, "\" CHECK (").concat(checkConstraint.expression, ")"));
    }
    /**
     * Builds drop check constraint sql.
     */
  }, {
    key: "dropCheckConstraintSql",
    value: function dropCheckConstraintSql(table, checkOrName) {
      var checkName = InstanceChecker.isTableCheck(checkOrName) ? checkOrName.name : checkOrName;
      return new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP CONSTRAINT \"").concat(checkName, "\""));
    }
    /**
     * Builds create exclusion constraint sql.
     */
  }, {
    key: "createExclusionConstraintSql",
    value: function createExclusionConstraintSql(table, exclusionConstraint) {
      return new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT \"").concat(exclusionConstraint.name, "\" EXCLUDE ").concat(exclusionConstraint.expression));
    }
    /**
     * Builds drop exclusion constraint sql.
     */
  }, {
    key: "dropExclusionConstraintSql",
    value: function dropExclusionConstraintSql(table, exclusionOrName) {
      var exclusionName = InstanceChecker.isTableExclusion(exclusionOrName) ? exclusionOrName.name : exclusionOrName;
      return new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP CONSTRAINT \"").concat(exclusionName, "\""));
    }
    /**
     * Builds create foreign key sql.
     */
  }, {
    key: "createForeignKeySql",
    value: function createForeignKeySql(table, foreignKey) {
      var columnNames = foreignKey.columnNames.map(function (column) {
        return "\"" + column + "\"";
      }).join(", ");
      var referencedColumnNames = foreignKey.referencedColumnNames.map(function (column) {
        return "\"" + column + "\"";
      }).join(",");
      var sql = "ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT \"").concat(foreignKey.name, "\" FOREIGN KEY (").concat(columnNames, ") ") + "REFERENCES ".concat(this.escapePath(this.getTablePath(foreignKey)), "(").concat(referencedColumnNames, ")");
      if (foreignKey.onDelete) sql += " ON DELETE ".concat(foreignKey.onDelete);
      if (foreignKey.onUpdate) sql += " ON UPDATE ".concat(foreignKey.onUpdate);
      if (foreignKey.deferrable) sql += " DEFERRABLE ".concat(foreignKey.deferrable);
      return new Query(sql);
    }
    /**
     * Builds drop foreign key sql.
     */
  }, {
    key: "dropForeignKeySql",
    value: function dropForeignKeySql(table, foreignKeyOrName) {
      var foreignKeyName = InstanceChecker.isTableForeignKey(foreignKeyOrName) ? foreignKeyOrName.name : foreignKeyOrName;
      return new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP CONSTRAINT \"").concat(foreignKeyName, "\""));
    }
    /**
     * Builds sequence name from given table and column.
     */
  }, {
    key: "buildSequenceName",
    value: function buildSequenceName(table, columnOrName) {
      var _this$driver$parseTab6 = this.driver.parseTableName(table),
        tableName = _this$driver$parseTab6.tableName;
      var columnName = InstanceChecker.isTableColumn(columnOrName) ? columnOrName.name : columnOrName;
      var seqName = "".concat(tableName, "_").concat(columnName, "_seq");
      if (seqName.length > this.connection.driver.maxAliasLength) {
        // note doesn't yet handle corner cases where .length differs from number of UTF-8 bytes
        seqName = "".concat(tableName.substring(0, 29), "_").concat(columnName.substring(0, Math.max(29, 63 - table.name.length - 5)), "_seq");
      }
      return seqName;
    }
  }, {
    key: "buildSequencePath",
    value: function buildSequencePath(table, columnOrName) {
      var _this$driver$parseTab7 = this.driver.parseTableName(table),
        schema = _this$driver$parseTab7.schema;
      return schema ? "".concat(schema, ".").concat(this.buildSequenceName(table, columnOrName)) : this.buildSequenceName(table, columnOrName);
    }
    /**
     * Builds ENUM type name from given table and column.
     */
  }, {
    key: "buildEnumName",
    value: function buildEnumName(table, column) {
      var withSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var disableEscape = arguments.length > 3 ? arguments[3] : undefined;
      var toOld = arguments.length > 4 ? arguments[4] : undefined;
      var _this$driver$parseTab8 = this.driver.parseTableName(table),
        schema = _this$driver$parseTab8.schema,
        tableName = _this$driver$parseTab8.tableName;
      var enumName = column.enumName ? column.enumName : "".concat(tableName, "_").concat(column.name.toLowerCase(), "_enum");
      if (schema && withSchema) enumName = "".concat(schema, ".").concat(enumName);
      if (toOld) enumName = enumName + "_old";
      return enumName.split(".").map(function (i) {
        return disableEscape ? i : "\"".concat(i, "\"");
      }).join(".");
    }
  }, {
    key: "getUserDefinedTypeName",
    value: function () {
      var _getUserDefinedTypeName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee68(table, column) {
        var _this$driver$parseTab9, schema, name, result, udtName;
        return _regeneratorRuntime().wrap(function _callee68$(_context68) {
          while (1) switch (_context68.prev = _context68.next) {
            case 0:
              _this$driver$parseTab9 = this.driver.parseTableName(table), schema = _this$driver$parseTab9.schema, name = _this$driver$parseTab9.tableName;
              if (schema) {
                _context68.next = 5;
                break;
              }
              _context68.next = 4;
              return this.getCurrentSchema();
            case 4:
              schema = _context68.sent;
            case 5:
              _context68.next = 7;
              return this.query("SELECT \"udt_schema\", \"udt_name\" " + "FROM \"information_schema\".\"columns\" WHERE \"table_schema\" = '".concat(schema, "' AND \"table_name\" = '").concat(name, "' AND \"column_name\"='").concat(column.name, "'"));
            case 7:
              result = _context68.sent;
              // docs: https://www.postgresql.org/docs/current/xtypes.html
              // When you define a new base type, PostgreSQL automatically provides support for arrays of that type.
              // The array type typically has the same name as the base type with the underscore character (_) prepended.
              // ----
              // so, we must remove this underscore character from enum type name
              udtName = result[0]["udt_name"];
              if (udtName.indexOf("_") === 0) {
                udtName = udtName.substr(1, udtName.length);
              }
              return _context68.abrupt("return", {
                schema: result[0]["udt_schema"],
                name: udtName
              });
            case 11:
            case "end":
              return _context68.stop();
          }
        }, _callee68, this);
      }));
      function getUserDefinedTypeName(_x110, _x111) {
        return _getUserDefinedTypeName.apply(this, arguments);
      }
      return getUserDefinedTypeName;
    }()
    /**
     * Escapes a given comment so it's safe to include in a query.
     */
  }, {
    key: "escapeComment",
    value: function escapeComment(comment) {
      if (!comment || comment.length === 0) {
        return "NULL";
      }
      comment = comment.replace(/'/g, "''").replace(/\u0000/g, ""); // Null bytes aren't allowed in comments
      return "'".concat(comment, "'");
    }
    /**
     * Escapes given table or view path.
     */
  }, {
    key: "escapePath",
    value: function escapePath(target) {
      var _this$driver$parseTab10 = this.driver.parseTableName(target),
        schema = _this$driver$parseTab10.schema,
        tableName = _this$driver$parseTab10.tableName;
      if (schema && schema !== this.driver.searchSchema) {
        return "\"".concat(schema, "\".\"").concat(tableName, "\"");
      }
      return "\"".concat(tableName, "\"");
    }
    /**
     * Get the table name with table schema
     * Note: Without ' or "
     */
  }, {
    key: "getTableNameWithSchema",
    value: function () {
      var _getTableNameWithSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee69(target) {
        var tableName, schemaResult, schema;
        return _regeneratorRuntime().wrap(function _callee69$(_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              tableName = InstanceChecker.isTable(target) ? target.name : target;
              if (!(tableName.indexOf(".") === -1)) {
                _context69.next = 9;
                break;
              }
              _context69.next = 4;
              return this.query("SELECT current_schema()");
            case 4:
              schemaResult = _context69.sent;
              schema = schemaResult[0]["current_schema"];
              return _context69.abrupt("return", "".concat(schema, ".").concat(tableName));
            case 9:
              return _context69.abrupt("return", "".concat(tableName.split(".")[0], ".").concat(tableName.split(".")[1]));
            case 10:
            case "end":
              return _context69.stop();
          }
        }, _callee69, this);
      }));
      function getTableNameWithSchema(_x112) {
        return _getTableNameWithSchema.apply(this, arguments);
      }
      return getTableNameWithSchema;
    }()
    /**
     * Builds a query for create column.
     */
  }, {
    key: "buildCreateColumnSql",
    value: function buildCreateColumnSql(table, column) {
      var c = '"' + column.name + '"';
      if (column.isGenerated === true && column.generationStrategy !== "uuid") {
        if (column.generationStrategy === "identity") {
          // Postgres 10+ Identity generated column
          var generatedIdentityOrDefault = column.generatedIdentity || "BY DEFAULT";
          c += " ".concat(column.type, " GENERATED ").concat(generatedIdentityOrDefault, " AS IDENTITY");
        } else {
          // classic SERIAL primary column
          if (column.type === "integer" || column.type === "int" || column.type === "int4") c += " SERIAL";
          if (column.type === "smallint" || column.type === "int2") c += " SMALLSERIAL";
          if (column.type === "bigint" || column.type === "int8") c += " BIGSERIAL";
        }
      }
      if (column.type === "enum" || column.type === "simple-enum") {
        c += " " + this.buildEnumName(table, column);
        if (column.isArray) c += " array";
      } else if (!column.isGenerated || column.type === "uuid") {
        c += " " + this.connection.driver.createFullType(column);
      }
      // Postgres only supports the stored generated column type
      if (column.generatedType === "STORED" && column.asExpression) {
        c += " GENERATED ALWAYS AS (".concat(column.asExpression, ") STORED");
      }
      if (column.charset) c += ' CHARACTER SET "' + column.charset + '"';
      if (column.collation) c += ' COLLATE "' + column.collation + '"';
      if (column.isNullable !== true) c += " NOT NULL";
      if (column.default !== undefined && column.default !== null) c += " DEFAULT " + column.default;
      if (column.isGenerated && column.generationStrategy === "uuid" && !column.default) c += " DEFAULT ".concat(this.driver.uuidGenerator);
      return c;
    }
    /**
     * Checks if the PostgreSQL server has support for partitioned tables
     */
  }, {
    key: "hasSupportForPartitionedTables",
    value: function () {
      var _hasSupportForPartitionedTables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee70() {
        var result;
        return _regeneratorRuntime().wrap(function _callee70$(_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              _context70.next = 2;
              return this.query("SELECT TRUE FROM information_schema.columns WHERE table_name = 'pg_class' and column_name = 'relispartition'");
            case 2:
              result = _context70.sent;
              return _context70.abrupt("return", result.length ? true : false);
            case 4:
            case "end":
              return _context70.stop();
          }
        }, _callee70, this);
      }));
      function hasSupportForPartitionedTables() {
        return _hasSupportForPartitionedTables.apply(this, arguments);
      }
      return hasSupportForPartitionedTables;
    }()
  }]);
  return PostgresQueryRunner;
}(BaseQueryRunner);